<ion-content class="container" 
*ngIf="loggedInUserIsMD">
  <ion-row *ngIf="!router.url.includes('Setup')">
    <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0"> 
      <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
        <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
          (selectedTabChange)="tabTypeChanged($event)">
          <mat-tab label="Dashboard">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  speed
                </span>Dashboard</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Increment Input">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  group
                </span>Increment Input</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Increment Summary">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  ads_click
                </span>Increment Summary</span>
            </ng-template>
          </mat-tab>
          <mat-tab label="Reports">
            <ng-template mat-tab-label>
              <span style="display: contents;">
                <span class="material-icons mr-10">
                  description
                </span>Reports</span>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </ion-col>
    <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class="borderbottomForTab pl-10 pt-10 pr-10"
      *ngIf="!router.url.includes('Setup') && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' || isShowMD)">   
    <div class="center-content float-right">
      <div *ngIf="!isShowMD">
        <span class="cp fs-14 link font_regular center-content mr-20" (click)="onClickLogs('Logs')">
          <img src="././assets/icon/logsIcon.svg"><u>Logs</u></span>
      </div>
      <div>
        <button type="button" class="add_btn fs-14 float-right center-content mr-5" [style.background-color]="buttonColorName"
        (click)="onClickSetup('Setup')">
        <span class="material-icons fs-20 mr-5">settings</span>Setup</button>
      </div>
    </div>
    </ion-col>
  </ion-row> 

   <!-- -------------------------------------- Dashboard ----------------------------------- -->
   <div class="container" *ngIf="selectedTypeTabName == 'Dashboard'">
    <div class="pt-10">
      <ion-row class="center-content">
          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="verticle-center" style="gap:10px">
             <div>
              <mat-form-field class="w150 mat-height40 mat-input-style">
                <mat-select placeholder="FY Year" [(ngModel)]="IncrementFyYear" (selectionChange)="selectedIncrementFYYear($event)">
                  <mat-option [value]="item.year" *ngFor="let item of getIncrementFyYearList">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                </mat-select>
              </mat-form-field>
             </div>
              <div>
                <p *ngIf="!completeStatusErrorMsg" class="fs-16 red text-center">setup is not completed</p>
              </div>
              <!-- <mat-form-field class="w200 mat-height40 mat-input-style">
                <mat-select placeholder="Select Manager">
                  <mat-option ></mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="w200 mat-height40 mat-input-style">
                <mat-select placeholder="Select Employee">
                  <mat-option ></mat-option>
                </mat-select>
              </mat-form-field> -->
            </div>   
          </ion-col>
          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="increment-period">
              <!-- <p>Increment Period - <span>{{fromIncremnetPeriod}}</span> to <span>{{toIncremnetPeriod}}</span> | Cut of date: <span>{{cutOffDateForIncrementEligibility | date: 'dd-MM-yyyy'}}</span></p> -->
              <p>Increment period with fiscal year - <span>{{sharedService.transformYearToFyFormat(selectedYear)}}</span> | Cut off date: <span>{{cutOffDateForIncrementEligibility | date: 'dd-MM-yyyy'}}</span></p>
              <!-- <span class="ml-5 mr-5 icon-download fs-20 material-icons">download</span> -->
            </div>
          </ion-col>
      </ion-row>
    </div>
    <div>
      <ion-row class="pt-10">
        <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
          <div class="card">
            <div class="verticle-center">
              <div class="icon-wrapper">
                <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
              </div>
              <div class="text-wrapper">
                <p class="fs-14 font_semibold">Budget %</p>
                <p class="mt-5 fs-14 font_bold blue">{{budgetPercentage}} ({{sharedService.transformNumber(budgetAmount)|| null}})</p>
              </div>
            </div>     
          </div>
        </ion-col>
      
        <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
          <div class="card">
            <div class="verticle-center">
              <div class="icon-wrapper">
                <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
              </div>
              <div class="text-wrapper">
                <p class="fs-14 font_semibold">No. of employees</p>
                <p class="mt-5 fs-14 font_bold yellow">{{noOfEmployees}}</p>
              </div>
            </div>
          </div>
        </ion-col>
      
        <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
          <div class="card" (click)="onClickMarketCorrectionEmp()">
            <div class="verticle-center">
              <div class="icon-wrapper">
                <span><img class="cp" src="././assets/icon/activeEmp.svg" alt=""></span>  
              </div>
              <div class="text-wrapper">
                <p class="fs-14 font_semibold cp">Market correction emp.</p>
                <p class="mt-5 fs-14 font_bold text_green cp">{{marketCorrectionEmp}}</p>
              </div>
            </div>
          </div>
        </ion-col>
      
        <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
          <div class="card" (click)="onClickEmpGivenPromotion()">
            <div class="verticle-center">
              <div class="icon-wrapper">
                <span><img class="cp" src="././assets/icon/activeEmp.svg" alt=""></span>  
              </div>
              <div class="text-wrapper">
                <p class="fs-14 font_semibold cp">Emp. given promotion</p>
                <p class="mt-5 fs-14 font_bold Cerulean-Blue cp">{{empGivenPromotion}}</p>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="pt-10">
        <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
          <div class="card" >
            <div class="verticle-center">
              <div class="icon-wrapper">
                <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
              </div>
              <div class="text-wrapper">
                <p class="fs-14 font_semibold">Avg. % of Overall Increment</p>
                <p class="mt-5 fs-14 font_bold red">{{avgPercentageOfOverallIncrement}}</p>
              </div>
            </div> 
          </div>
        </ion-col>
      
        <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
          <div class="card" (click)="onClickEligibleEmployees()">
            <div class="verticle-center">
              <div class="icon-wrapper">
                <span><img class="cp" src="././assets/icon/activeEmp.svg" alt=""></span>  
              </div>
              <div class="text-wrapper">
                <p class="fs-14 font_semibold cp">Eligible employees</p>
                <p class="mt-5 fs-14 font_bold text-rich-blue cp" >{{eligibleEmps}}</p>
              </div>
            </div>
          </div>
        </ion-col>
      
        <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
          <div class="card">
            <div class="verticle-center">
              <div class="icon-wrapper">
                <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
              </div>
              <div class="text-wrapper">
                <p class="fs-14 font_semibold">Avg. % of market correc.</p>
                <p class="mt-5 fs-14 font_bold Medium-Turquoise-blue">{{avgPercentageOfMarketCorrection}}</p>
              </div>
            </div>
          </div>
        </ion-col>
      
        <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
          <div class="card">
            <div class="verticle-center">
              <div class="icon-wrapper">
                <span><img src="././assets/icon/activeEmp.svg" alt=""></span>  
              </div>
              <div class="text-wrapper">
                <p class="fs-14 font_semibold">Avg. % of promotion inc</p>
                <p class="mt-5 fs-14 font_bold red">{{avgPercentageOfPromotionIncrement}}</p>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </div>
    <div>
      <ion-row class="pt-10">
        <!-- Budget vs Actual Graph -->
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs m-50">
            <ion-row class="justify-content-center">
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <div class="fs-16 font_bold">Budget vs Actual</div>
              </ion-col>
              <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                <div class="d-flex graph-icon">
                  <span class="cp" (click)="OnClickDownloadBudgetvsActualGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>  
                </div>
              </ion-col>
            </ion-row>
        <div id="budgetVsActualGraph" style="width: 100%; height: 400px;"></div>
        </div>
        </ion-col>
      
        <!-- Gender wise - Budget vs Actual Graph -->

        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs m-50">
            <ion-row class="justify-content-center">
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <div class="fs-16 font_bold">Gender wise - Budget vs Actual</div>
              </ion-col>
              <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                <div class="d-flex graph-icon">
                  <span (click)="switchGenderWiseBudgetVsActualGraphType('bar')">
                  <img *ngIf="generWiseBudgetVsActualIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                  <img *ngIf="generWiseBudgetVsActualIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>

                  <span (click)="GenderWiseBudgetVsActualTableData()">
                    <img *ngIf="!GenerWiseBudgetVsActualTable" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="GenerWiseBudgetVsActualTable" src="././assets/icon/TableIconActive.svg" alt="">
                </span>

                  <span (click)="switchGenderWiseBudgetVsActualGraphType('line')">
                    <img *ngIf="generWiseBudgetVsActualIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="generWiseBudgetVsActualIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadGenderWiseBudgetVsActualGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>  
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
            <ion-row>
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <ng-select class="w250 mat mat-height40 mb-10 mat-input-style mr-15"  placeholder="Select Department" [(ngModel)]="selectGenderWiseBudgetVsActualDept"
                (change)="selectedGenderWieBudgetVsActualDept()">
                <ng-option
                *ngFor="let data of getDepartmentByYearList" [value]="data.name">{{data.name}}
              </ng-option>
              </ng-select>
                <!-- <mat-form-field class="w-250 mat mat-height40 mb-10 mat-input-style mr-15">
                  <mat-select placeholder="Select Department" [(ngModel)]="selectGenderWiseBudgetVsActualDept"
                    (selectionChange)="selectedGenderWieBudgetVsActualDept()">                  
                    <mat-option *ngFor="let data of getDepartmentByYearList" [value]="data.name">{{data.name}}</mat-option>
                  </mat-select>
                </mat-form-field> -->
              </ion-col>
            </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : GenerWiseBudgetVsActualTable}">
              <div id="GenderWiseBudgetVsActualGraph" style="width: 100%; height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !GenerWiseBudgetVsActualTable}" id="genderWiseBudgetVsActualTable">
              <table class="dashboardGraphTable">
                <thead>
                  <tr>
                    <th>Gender</th>
                    <th>Budget Amount</th>
                    <th>Actual Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of getGenderWiseBudgetVsActualData">
                    <td>{{data.gender}}</td>
                <td>{{sharedService.transformNumber(data.budgetAmount)}}</td>
                    <td>{{sharedService.transformNumber(data.actualAmount)}}</td>
                  </tr>
                </tbody>
              </table>
              </div> 
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        
        <!-- Budget vs actual Increment Graph -->

        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row class="justify-content-center">
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <div class="fs-16 font_bold p-10">Budget vs actual Increment</div>
              </ion-col>
              <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
               <div class="d-flex graph-icon">
                  <span (click)="switchBudgetVsActualIncrementGraphType('bar')">
                  <img *ngIf="budgetVsActualIncrementIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                  <img *ngIf="budgetVsActualIncrementIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>

                  <span (click)="switchBudgetVsActualIncrementTable()">
                    <img *ngIf="!budgetVsActualIncrementIconTable" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="budgetVsActualIncrementIconTable" src="././assets/icon/TableIconActive.svg" alt="">
                </span>

                  <span (click)="switchBudgetVsActualIncrementGraphType('line')">
                    <img *ngIf="budgetVsActualIncrementIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="budgetVsActualIncrementIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadBudgetVsActualIncrementGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>  
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                <ng-multiselect-dropdown class="ml-5 w-100"
                [placeholder]="'Select Department'"
                [settings]="dropdownSettings" 
                [data]="getDepartmentByYearList"
                [(ngModel)]="selectedBudgetVsActualIncrementDept" 
                (onSelect)="onSelectBudgetVsActualIncrementDept()"
                (onDeSelect)="onDeSelectBudgetVsActualIncrementDept()"
                (onSelectAll)="selectAllBudgetVsActualIncrementDept($event)"
                (onDeSelectAll)="onDeSelectAllBudgetVsActualIncrementDept()">
                </ng-multiselect-dropdown>
              </ion-col>
            </ion-row>
            <div [ngClass]="{'dispNone' : budgetVsActualIncrementIconTable}">
              <div id="BudgetvsActualIncrementStatusGraph" style="width: 100%; height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !budgetVsActualIncrementIconTable}" id="budgetvsActualIncrementStatusTable">
              <div class="dashboardGraphTable">
                <table >
                  <thead>
                    <tr>
                      <th>Department </th>
                      <th>Budget Amount</th>
                      <th>Actual Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of getBudgetVsActualIncrementData">
                      <td>{{data.department}}</td>
                    <td>{{sharedService.transformNumber(data.budgetAmount)}}</td>
                    <td>{{sharedService.transformNumber(data.actualAmount)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>  
          </div>
        </ion-col>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row class="justify-content-center">
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <div class="fs-16 font_bold">Rating wise increment amount (budget vs actual)</div>
              </ion-col>
              <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                <div class="d-flex graph-icon">
                  <span (click)="switchRatingWiseIncrementAmountGraphType('bar')">
                  <img *ngIf="ratingWiseIncrementAmountIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                  <img *ngIf="ratingWiseIncrementAmountIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>

                  <span (click)="switchRatingWiseIncrementAmountTableData()">
                    <img *ngIf="!ratingWiseIncrementAmountTable" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="ratingWiseIncrementAmountTable" src="././assets/icon/TableIconActive.svg" alt="">
                </span>

                  <span (click)="switchRatingWiseIncrementAmountGraphType('line')">
                    <img *ngIf="ratingWiseIncrementAmountIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="ratingWiseIncrementAmountIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadRatingWiseIncrementAmountGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>  
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
            <ion-row>
              <ion-col size-sm="8" size-md="6" size-lg="6" size-xs="8">
                <ng-select class="w250 mat mat-height40 mb-10 mat-input-style mr-15"  placeholder="Select Department" [(ngModel)]="selectRatingWiseIncrementAmount"
                (change)="selectedRatingWiseIncrementAmount()">
                <ng-option
                *ngFor="let data of getDepartmentByYearList" [value]="data.name">{{data.name}}
              </ng-option>
              </ng-select>

                <!-- <mat-form-field class="w-100 mat mat-height40 mb-10  mat-input-style mr-15">
                  <mat-select placeholder="Select Department" [(ngModel)]="selectRatingWiseIncrementAmount" 
                  (selectionChange)="selectedRatingWiseIncrementAmount()">
                    <mat-option *ngFor="let data of getDepartmentByYearList" [value]="data.name">{{data.name}}</mat-option>
                  </mat-select>
                </mat-form-field> -->
              </ion-col>
            </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : ratingWiseIncrementAmountTable}">
              <div id="ratingWiseIncrementAmountStatusGraph" style="width: 90%; height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !ratingWiseIncrementAmountTable}" id="ratingWiseIncrementAmountStatusTable">
              <table class="dashboardGraphTable">
                <thead>
                  <tr>
                    <th>Ratings </th>
                    <th>Budget Amount</th>
                    <th>Actual Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of ratingWiseIncrementAmountData">
                    <td>{{data.rating}}</td>
                    <td>{{sharedService.transformNumber(data.budgetAmount)}}</td>
                    <td>{{sharedService.transformNumber(data.actualAmount)}}</td>
                  </tr>
                </tbody>
              </table>
              </div>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row class="justify-content-center">
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <div class="fs-16 font_bold">Band wise budget Vs actuals</div>
              </ion-col>
              <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                <div class="d-flex graph-icon">
                  <span (click)="switchBandWiseBudgetVsActualsGraphType('bar')">
                  <img *ngIf="bandWiseBudgetVsActualsIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                  <img *ngIf="bandWiseBudgetVsActualsIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>


                  <span (click)="switchBandWiseBudgetVsActualsTableData()">
                    <img *ngIf="!bandWiseBudgetVsActualsTable" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="bandWiseBudgetVsActualsTable" src="././assets/icon/TableIconActive.svg" alt="">
                </span>

                  <span (click)="switchBandWiseBudgetVsActualsGraphType('line')">
                    <img *ngIf="bandWiseBudgetVsActualsIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="bandWiseBudgetVsActualsIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadBandWiseBudgetVsActualsGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>  
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
            <ion-row>
              <ion-col size-sm="8" size-md="6" size-lg="6" size-xs="8">
                <ng-select class="w250 mat mat-height40 mb-10 mat-input-style mr-15"  placeholder="Select Department" [(ngModel)]="selectBandWiseBudgetVsActuals"
                (change)="selectedBandWiseBudgetVsActuals()">
                <ng-option
                *ngFor="let data of getDepartmentByYearList" [value]="data.name">{{data.name}}
              </ng-option>
              </ng-select>
                <!-- <mat-form-field class="w-100 mat mat-height40 mb-10  mat-input-style mr-15">
                  <mat-select placeholder="Select Department" [(ngModel)]="selectBandWiseBudgetVsActuals"
                  (selectionChange)="selectedBandWiseBudgetVsActuals()">
                    <mat-option *ngFor="let data of getDepartmentByYearList" [value]="data.name">{{data.name}}</mat-option>
                  </mat-select>
                </mat-form-field> -->
              </ion-col>
            </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : bandWiseBudgetVsActualsTable}">
              <div id="bandWiseBudgetVsActualsStatusGraph" style="width: 100%; height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !bandWiseBudgetVsActualsTable}" id="bandWiseBudgetVsActualsStatusTable">
              <table class="dashboardGraphTable">
                <thead>
                  <tr>
                    <th>Bands </th>
                    <th>Budget Amount</th>
                    <th>Actual Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of bandWiseBudgetVsActualsData">
                    <td>{{data.band}}</td>
                    <td>{{sharedService.transformNumber(data.budgetAmount)}}</td>
                    <td>{{sharedService.transformNumber(data.actualAmount)}}</td>
                  </tr>
                </tbody>
              </table>
              </div>
          </div>
        </ion-col>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row class="justify-content-center">
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <div class="fs-16 font_bold">Rating vs Employee count</div>
              </ion-col>
              <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                <div class="d-flex graph-icon">
                  <span (click)="switchRatingVsEmpCountGraphType('bar')">
                  <img *ngIf="ratingVsEmpCountIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                  <img *ngIf="ratingVsEmpCountIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>

                  <span (click)="switchRatingVsEmpCountGraphType('pie')">
                    <img *ngIf="ratingVsEmpCountIcon != 'pie'" src="././assets/icon/pieChartIcon.svg" alt="">
                    <img *ngIf="ratingVsEmpCountIcon == 'pie'" src="././assets/icon/PieIconActive.svg" alt="">
                  </span>

                  <span (click)="switchRatingVsEmpCountTable()">
                    <img *ngIf="!ratingVsEmpCountTable" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="ratingVsEmpCountTable" src="././assets/icon/TableIconActive.svg" alt="">
                </span>

                  <span (click)="switchRatingVsEmpCountGraphType('line')">
                    <img *ngIf="ratingVsEmpCountIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="ratingVsEmpCountIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="OnClickDownloadRatingVsEmpCountGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>  
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
            <ion-row>
              <ion-col size-sm="8" size-md="6" size-lg="6" size-xs="8">
                <ng-select class="w250 mat mat-height40 mb-10 mat-input-style mr-15"  placeholder="Select Department" [(ngModel)]="selectratingVsEmpCount"
                (change)="selectedratingVsEmpCount()">
                <ng-option
                *ngFor="let data of getDepartmentByYearList" [value]="data.name">{{data.name}}
              </ng-option>
              </ng-select>
                <!-- <mat-form-field class="w-100 mat mat-height40 mb-10  mat-input-style mr-15">
                  <mat-select placeholder="Select Department" [(ngModel)]="selectratingVsEmpCount"
                  (selectionChange)="selectedratingVsEmpCount()">
                    <mat-option *ngFor="let data of getDepartmentByYearList" [value]="data.name">{{data.name}}</mat-option>
                  </mat-select>
                </mat-form-field> -->
              </ion-col>
            </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : ratingVsEmpCountTable}">
              <div id="ratingvsEmployeeCountStatusGraph" style="width: 100%; height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !ratingVsEmpCountTable}" id="ratingvsEmployeeCountStatusTable">
              <table class="dashboardGraphTable">
                <thead>
                  <tr>
                    <th>Rating</th>
                    <th>Employee Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of ratingVsEmpCountData">
                    <td>{{data.rating}}</td>
                    <td>{{sharedService.transformNumber(data.employeeCount)}}</td>
                  </tr>
                </tbody>
              </table>
              </div>
          </div>
        </ion-col>
      </ion-row>


      <ion-row>
        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row class="justify-content-center">
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <div class="fs-16 font_bold">Year vs Budget & Actual Amount</div>
              </ion-col>
              <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                <div class="d-flex graph-icon">
                  <span (click)="switchYearVsBudgetAndActualAmountGraphType('bar')">
                  <img *ngIf="yearVsBudgetAndActualAmountIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                  <img *ngIf="yearVsBudgetAndActualAmountIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>

                  <span (click)="switchYearVsBudgetAndActualAmountTable()">
                    <img *ngIf="!yearVsBudgetAndActualAmountTable" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="yearVsBudgetAndActualAmountTable" src="././assets/icon/TableIconActive.svg" alt="">
                </span>

                  <span (click)="switchYearVsBudgetAndActualAmountGraphType('line')">
                    <img *ngIf="yearVsBudgetAndActualAmountIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="yearVsBudgetAndActualAmountIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadYearVsBudgetAndActualAmountGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>  
                </div>
              </ion-col>
            </ion-row>
            <div class="mt-10 mb-10">
            <ion-row>
              <ion-col size-sm="8" sizemd="6" size-lg="6" size-xs="8">
                <ng-select class="w250 mat mat-height40 mb-10 mat-input-style mr-15"  placeholder="Select Department" [(ngModel)]="selectYearVsBudgetAndActualAmount"
                (change)="selectedYearVsBudgetAndActualAmount()">
                <ng-option
                *ngFor="let data of getDepartmentByYearList" [value]="data.name">{{data.name}}
              </ng-option>
              </ng-select>

                <!-- <mat-form-field class="w-100 mat mat-height40 mb-10  mat-input-style mr-15">
                  <mat-select placeholder="Select Department" [(ngModel)]="selectYearVsBudgetAndActualAmount"
                  (selectionChange)="selectedYearVsBudgetAndActualAmount()">
                    <mat-option *ngFor="let data of getDepartmentByYearList" [value]="data.name">{{data.name}}</mat-option>
                  </mat-select>
                </mat-form-field> -->
              </ion-col>
            </ion-row>
            </div>
            <div [ngClass]="{'dispNone' : yearVsBudgetAndActualAmountTable}">
              <div id="yearVsBudgetandActualAmountStatusGraph" style="width: 100%; height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !yearVsBudgetAndActualAmountTable}" id="yearVsBudgetandActualAmountStatusTable">
              <table class="dashboardGraphTable">
                <thead>
                  <tr>
                    <th>Year </th>
                    <th>Budget Amount</th>
                    <th>Actual Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of yearVsBudgetAndActualAmountData">
                    <td>{{data.year}}</td>
                    <td>{{sharedService.transformNumber(data.budgetAmount)}}</td>
                    <td>{{sharedService.transformNumber(data.actualAmount)}}</td>
                  </tr>
                </tbody>
              </table>
              </div>
          </div>
        </ion-col>

        <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
          <div class="graphs">
            <ion-row class="justify-content-center">
              <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
                <div class="fs-16 font_bold">Dept wise Eligible and not eligible employee count</div>
              </ion-col>
              <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
                <div class="d-flex graph-icon">
                  <span (click)="switchDeptWiseEligibleAndNonEligibleEmpCountGraphType('bar')">
                  <img *ngIf="deptWiseEligibleAndNonEligibleEmpCountIcon != 'bar'" src="././assets/icon/BarGraphIcon.svg" alt="">
                  <img *ngIf="deptWiseEligibleAndNonEligibleEmpCountIcon == 'bar'" src="././assets/icon/BarGraphActive.svg" alt="">
                </span>

                  <span (click)="switchDeptWiseEligibleAndNonEligibleEmpCountTable()">
                    <img *ngIf="!deptWiseEligibleAndNonEligibleEmpCountTable" src="././assets/icon/tableIcon.svg" alt="">
                    <img *ngIf="deptWiseEligibleAndNonEligibleEmpCountTable" src="././assets/icon/TableIconActive.svg" alt="">
                </span>

                  <span (click)="switchDeptWiseEligibleAndNonEligibleEmpCountGraphType('line')">
                    <img *ngIf="deptWiseEligibleAndNonEligibleEmpCountIcon != 'line'" src="././assets/icon/lineChartIcon.svg" alt="">
                    <img *ngIf="deptWiseEligibleAndNonEligibleEmpCountIcon == 'line'" src="././assets/icon/activeLineChart.svg" alt="">
                  </span>

                  <span class="cp" (click)="downloadDeptWiseEligibleEmpCoungGraph()"><img src="././assets/icon/downloadIcon.svg" alt=""></span>  
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size-sm="8" size-md="6" size-lg="6" size-xs="8">
                <ng-multiselect-dropdown class="ml-5 w-100"
                [placeholder]="'Select Department'"
                [settings]="dropdownSettings" 
                [data]="getDepartmentByYearList"
                [(ngModel)]="selectDeptWiseEligibleAndNonEligibleEmp" 
                (onSelect)="onSelectselectedDeptWiseEligibleAndNonEligibleEmpCount()"
                (onDeSelect)="onDeSelectselectedDeptWiseEligibleAndNonEligibleEmpCount()"
                (onSelectAll)="selectAllselectedDeptWiseEligibleAndNonEligibleEmpCount($event)"
                (onDeSelectAll)="onDeSelectAllselectedDeptWiseEligibleAndNonEligibleEmpCount()">
                </ng-multiselect-dropdown>
              </ion-col>
            </ion-row>
            <div [ngClass]="{'dispNone' : deptWiseEligibleAndNonEligibleEmpCountTable}">
              <div id="deptWiseEligibleAndNonEligibleEmpCountStatusGraph" style="width: 100%; height: 400px;"></div>
            </div>
            <div [ngClass]="{'dispNone' : !deptWiseEligibleAndNonEligibleEmpCountTable}" id="deptWiseEligibleAndNonEligibleEmpCountStatusTable">
              <table class="dashboardGraphTable">
                <thead>
                  <tr>
                    <th>Department </th>
                    <th>Eligible Count</th>
                    <th>Non Eligible Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of deptWiseEligibleAndNonEligibleEmpCountData">
                    <td>{{data.department}}</td>
                    <td>{{sharedService.transformNumber(data.eligibleCount)}}</td>
                    <td>{{sharedService.transformNumber(data.nonEligibleCount)}}</td>
                  </tr>
                </tbody>
              </table>
              </div>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>

  <!-- --------------------------------------Increment Input----------------------------------- -->

  <div class="container pb-20" *ngIf="selectedTypeTabName == 'Increment Input'">
    <ion-row class="pt-15">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
        <div class="d-flex"> 
          <button type="button" (click)="onClickIncrementIntputActiveTab(true)"
            [ngClass]="{'activeIncrementInputTab' : activeIncrementInputTab}"
            class="borderRadiusRight tabsBtn center-content fs-14"><span class="displayContent">
              Eligible ({{totalEligibleCount}})</span></button>
          <button type="button" (click)="onClickIncrementIntputActiveTab(false)"
            [ngClass]="{'activeIncrementInputTab' : !activeIncrementInputTab}"
            class="borderRadiusLeft tabsBtn center-content fs-14"><span class="displayContent">
              Non Eligible ({{totalNonEligibleCount}})</span></button>
        </div>
      </ion-col>
    </ion-row> 
    <ion-row class="pt-15">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
        <div class="d-flex reportsInputFields">
          <mat-form-field class="w150 mat-height40 mat-input-style">
            <mat-select placeholder="Select Year" [(ngModel)]="IncrementFyYear" (selectionChange)="selectedIncrementFYYear($event)" >
              <mat-option [value]="item.year" *ngFor="let item of getIncrementFyYearList">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
            </mat-select>
          </mat-form-field>
          <ng-multiselect-dropdown class="ml-5 w250" 
          [placeholder]="'Select Department'"
          [settings]="dropdownSettings" 
          [data]="getDepartmentByYearList"
          [(ngModel)]="selectedIncrementInputDept" 
          (onSelect)="onSelectIncrementInputDept()"
          (onDeSelect)="onDeSelectIncrementInputDept()"
          (onSelectAll)="selectAllIncrementInputDept($event)"
          (onDeSelectAll)="onDeSelectAllIncrementInputDept()"> 
        </ng-multiselect-dropdown>
        
        <ng-multiselect-dropdown class="ml-5 w250" 
          [placeholder]="'Select Band'"
          [settings]="dropdownSettings" 
          [data]="getBandList"
          [(ngModel)]="selectedIncrementInputBand" 
          (onSelect)="onSelectdIncrementInputBand()"
          (onDeSelect)="onDeSelectdIncrementInputBand()"
          (onSelectAll)="selectAllIncrementInputBand($event)"
          (onDeSelectAll)="onDeSelectAllIncrementInputBand()">
        </ng-multiselect-dropdown>

        <ng-multiselect-dropdown class="ml-5 w250" 
        [placeholder]="'Select Manager'"
        [settings]="dropdownSettings" 
        [data]="getManagerList"
        [(ngModel)]="selectedIncrementInputManager" 
        (onSelect)="onSelectIncrementInputdManager()"
        (onDeSelect)="onDeSelectdIncrementInputdManager()"
        (onSelectAll)="selectAllIncrementInputdManager($event)"
        (onDeSelectAll)="onDeSelectAllIncrementInputdManager()">
        </ng-multiselect-dropdown>

        <ng-multiselect-dropdown class="ml-5 w250" 
        [placeholder]="'Select Employee'" 
        [settings]="dropdownSettings" 
        [data]="getEmployeeList"
        [(ngModel)]="selectedIncrementInputEmp" 
        (onSelect)="onSelectdIncrementInputEmp()" 
        (onDeSelect)="onDeSelectdIncrementInputEmp()"
        (onSelectAll)="selectAllIncrementInputEmp($event)"
        (onDeSelectAll)="onDeSelectAllIncrementInputEmp()">
        </ng-multiselect-dropdown>
        </div>
      </ion-col>
    </ion-row>
    <div class="tableCardBox mt-15 mb-15">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
           <div class="display-space-between">
            <div class="d-flex">
              <mat-form-field class="mat-height40 mat-input-style">
                <mat-icon matPrefix>search</mat-icon>
                <input matInput type="search" placeholder="Search" [(ngModel)]="searchIncrementInputTableData"
                    (input)="onIncrementInputSearch(searchIncrementInputTableData)">
            </mat-form-field>
            </div>

            <div>
              <p *ngIf="!completeStatusErrorMsg" class="fs-16 red">setup is not completed</p>
            </div>

            <div class="d-flex float-right">
              <div class="mr-15 center-content" *ngIf="activeIncrementInputTab">
                <div class="font_regular fs-12">Status : <span style="color: #E94848;">{{ShowIncrementInputStatus}}</span> </div>
                <!-- <div *ngIf="afterMDAndCEOApproval" class="fs-12 font_semibold">Status : {{approvalStatus}} on {{approvalDateAndTime | date: 'dd-MM-yyyy'}}</div> -->
              </div>
  
              <div class="mr-15" *ngIf="isAnyColumnInvisible">
                <div class="font_regular fs-12">Some Columns are hidden-</div>
                <div class="font_regular fs-12 text-right" [style.color]="buttonColorName"><u class="cp"
                        (click)="onClickShowAllHeader()">click here to show all</u></div>
              </div>
  
              <button class="materialBtnIcon black_color fs-14 font_semibold mr-15" (click)="onClickDownloadIncrementInputExcelFile()">
                <span class="material-icons">download</span></button>
              <button [matMenuTriggerFor]="menu" [style.background-color]="buttonColorName"
                class="customMaterialIcon fs-14">
                <span class="material-icons">tune</span></button>
              <mat-menu #menu="matMenu" (closed)="onMenuClose()">
                <ion-row>
                  <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
                      *ngFor="let item of IncrementInputTableHideShowAllData" class="mat-checkbox-style">
                      <mat-checkbox [(ngModel)]="item.isVisible" class="fs-12 font_semibold "
                          (change)="onSelectIncrementInputHideShowCheckBox()" [checked]="item.isVisible"
                          value="true" (click)="$event.stopPropagation()"
                          value=true>{{item.fieldName}}</mat-checkbox>
                  </ion-col>
                  </ion-row>
              </mat-menu>
            </div>


           </div>
        </ion-col>
      </ion-row>
      <ion-row class="p-5 mt-5">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container" *ngIf="loggedInUserRole != 'HOD'" >
            <table class="increment-input-table" *ngIf="activeIncrementInputTab" id="incrementInputEligibleTable">
              <thead>
                <tr>
                  <ng-container *ngFor="let item of IncrementInputTableHideShowAllData; let i = index">
                    <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                        <div class="verticle-center justify-content-space-between icon-style">
                            {{item.fieldName}}
                            <span class="material-icons cp ml-5 mt-3 fs-14" *ngIf="!isShowExcelData"
                                (click)="updateIncrementInputColumnVisibility(item,i)">visibility_off</span>
                        </div>
                    </th>
                </ng-container>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let department of getIncrementInputEligibleTableData">
                  <ng-container *ngFor="let bandGrade of department.bandGrades; let i = index">
                    <ng-container *ngFor="let employee of bandGrade.employeeData; let j = index">
                      <tr>
                        <td *ngIf="getIncrementInputColumnVisibility('Department') && i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(department.bandGrades)">
                          {{ department.departmentName }}
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Band') && j === 0" [attr.rowspan]="bandGrade.employeeData.length">
                          {{ bandGrade.band }}
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Employee')">{{ employee.employeeName }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Manager')">{{ employee.managerName }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('HOD')">{{ employee.hodName }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Designation')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput type="text" placeholder="Type here" 
                            (blur)="onEditIncrementInputTableData(employee)"
                            [(ngModel)]="employee.designation"
                            [disabled]="disableIncrementInputFormToHrAdmin">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.designation}}</span>

                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('DOJ')">{{ employee.dateOfJoining | date: 'dd-MM-yyyy' }}
                          <!-- <span *ngIf="isShowExcelData && getFormatedDate(employee.dateOfJoining) as res" >{{getFormatedDate(employee.dateOfJoining)}}</span> -->
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerMonth)">{{employee.monthlyCtc | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerYear)">{{employee.annualCtc | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')">
                          <mat-form-field class="w150 mat-height40 mat-input-style">
                            <mat-select placeholder="Select" [(ngModel)]="employee.isEligible"
                            (selectionChange)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin">
                              <mat-option [value]="true">Yes</mat-option>
                              <mat-option [value]="false">No</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')">{{employee.individualKpiCompetencyScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')">{{employee.deptScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')">{{employee.companyScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Score')">{{employee.finalScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Rating')">{{employee.finalRating}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Increment %')">{{employee.incrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Days Served in the Increment Period')">{{employee.daysServed | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Prorated Increment %')">{{employee.proratedIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Increment Amount')">{{employee.incrementAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('No Promotion Last 3 Year')">{{employee.noOfPromotions | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Promotion')">
                          <mat-form-field class="w150 mat-height40 mat-input-style">
                            <mat-select placeholder="Select" [(ngModel)]="employee.isPromoted"
                            (selectionChange)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin">
                              <mat-option [value]="true">Yes</mat-option>
                              <mat-option [value]="false">No</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Promotion %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput type="text" type="number" 
                            [(ngModel)]="employee.promotionPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.promotionPercentage}}</span>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Promotion Amount')">{{employee.promotionAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Updated CTC after Increment & Promotion')">{{employee.updatedCtcAfterIncrementAndPromotion | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Market BenchMark CTC')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput type="number" placeholder="Type here"
                            [(ngModel)]="employee.marketBenchMarkCtc"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.marketBenchMarkCtc}}</span>

                        </td>            
                        <td *ngIf="getIncrementInputColumnVisibility('Market Correction %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput type="number" placeholder="Type here" 
                            [(ngModel)]="employee.marketCorrectionPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin">
                          </mat-form-field> 
                          <span *ngIf="isShowExcelData">{{employee.marketCorrectionPercentage}}</span>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Market Correction Amount')">{{employee.marketCorrectionAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Increment % p.a')">{{employee.finalIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(3))">{{employee.yearBeforeLastYrIncrementPercentage}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(2))">{{employee.lastToLastYrIncrementPercentage}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(1))">{{employee.lastYrIncrementPercentage}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('HOD Approved Increment %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.hodIncrementPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin || isEditHODApprovedIncrementPct">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.hodIncrementPercentage}}</span>
                          <!-- isHideHODApprovedIncrementPct  -->
                          <!-- [disabled]="disableIncrementInputFormToHrAdmin || isEditHODApprovedIncrementPct" -->
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('HR Admin & MD/CEO Approved Increment %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.hrAndMdIncrementPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin || isEditHRAdminAndMDCEOApprovedIncrementPct">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.hrAndMdIncrementPercentage}}</span>
                          <!-- isHideHRAdminAndMDCEOApprovedIncrementPct -->
                          <!-- [disabled]="disableIncrementInputFormToHOD || isEditHRAdminAndMDCEOApprovedIncrementPct"  -->
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Increment Amount')">{{employee.finalIncrementAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Annual Revised CTC (post increment)')">{{employee.finalAnnualCtc | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Monthly Revised CTC (post increment)')">{{employee.finalMonthlyCtc | number}}</td>
                        <td class="cp" *ngIf="getIncrementInputColumnVisibility('Increment Letter Format')" (click)="onClickShowIncrementLetter(employee.userId)">{{employee.incrementLetterFormat?.letterName || 'Letter not found'}}</td>                       
                      </tr>
                    </ng-container>
                  </ng-container>
                </ng-container>
               </tbody>
               <tfoot>
                <tr>
                  <td *ngIf="getIncrementInputColumnVisibility('Department')">Total</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Band')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Employee')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Manager')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('HOD')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Designation')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('DOJ')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerMonth)">{{totalEligibleTotalFixedCtcPM | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerYear)">{{totalEligibleTotalFixedCtcPA | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')">{{totalEligibleEligibleEmp | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Score')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Rating')">{{totalEligibleFinalRating | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Increment %')">{{totalEligibleIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Days Served in the Increment Period')">{{totalEligibleDaysServedinIncrementPeriod | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Prorated Increment %')">{{totalEligibleProratedIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Increment Amount')">{{totalEligibleIncrementAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('No Promotion Last 3 Year')">{{totalEligibleNoOfPromotionPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Promotion')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Promotion %')">{{totalEligiblePromotionPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Promotion Amount')">{{totalEligiblePromotionAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Updated CTC after Increment & Promotion')">{{totalEligibleupdatedCtcAfterIAndP | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Market BenchMark CTC')">{{totalEligibleMarketBenchMarkCtc | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Market Correction %')">{{totalEligiblemarketCorrectionPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Market Correction Amount')">{{totalEligibleMarketCorrectionAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Increment % p.a')">{{totalEligibleFinalIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(3))"></td>
                  <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(2))"></td>
                  <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(1))"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('HOD Approved Increment %')">{{totalEligibleHODIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('HR Admin & MD/CEO Approved Increment %')">{{totalEligibleHrAndMdIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Increment Amount')">{{totalEligibleFinalIncrementAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Annual Revised CTC (post increment)')">{{totalEligibleFinalAnnualCtc | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Monthly Revised CTC (post increment)')">{{totalEligibleFinalMonthlyCtc | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Increment Letter Format')"></td>
                </tr>
              </tfoot>
            </table>    
            
            <table class="increment-input-table" *ngIf="!activeIncrementInputTab" id="incrementInputNonEligibleTable">
              <thead>
                <tr>
                  <ng-container *ngFor="let item of IncrementInputTableHideShowAllData; let i = index">
                    <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                        <div class="verticle-center justify-content-space-between icon-style">
                            {{item.fieldName}}
                            <span class="material-icons cp ml-5 mt-3 fs-14" *ngIf="!isShowExcelData"
                                (click)="updateIncrementInputColumnVisibility(item,i)">visibility_off</span>
                        </div>
                    </th>
                </ng-container>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let department of getIncrementInputNonEligibleTableData">
                  <ng-container *ngFor="let bandGrade of department.bandGrades; let i = index">
                    <ng-container *ngFor="let employee of bandGrade.employeeData; let j = index">
                      <tr>
                        <td *ngIf="getIncrementInputColumnVisibility('Department') && i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(department.bandGrades)">
                          {{ department.departmentName }}
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Band') && j === 0" [attr.rowspan]="bandGrade.employeeData.length">
                          {{ bandGrade.band }}
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Employee')">{{ employee.employeeName }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Manager')">{{ employee.managerName }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('HOD')">{{ employee.hodName }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Designation')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="text" placeholder="Type here"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [(ngModel)]="employee.designation"
                            [disabled]="disableIncrementInputFormToHrAdmin">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.designation}}</span>

                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('DOJ')">{{ employee.dateOfJoining | date: 'dd-MM-yyyy' }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerMonth)">{{employee.monthlyCtc | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerYear)">{{employee.annualCtc | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')">
                          <mat-form-field class="w150 mat-height40 mat-input-style">
                            <mat-select placeholder="Select" [(ngModel)]="employee.isEligible"
                            (selectionChange)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin">
                              <mat-option [value]="true">Yes</mat-option>
                              <mat-option [value]="false">No</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')">{{employee.individualKpiCompetencyScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')">{{employee.deptScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')">{{employee.companyScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Score')">{{employee.finalScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Rating')">{{employee.finalRating}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Increment %')">{{employee.incrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Days Served in the Increment Period')">{{employee.daysServed | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Prorated Increment %')">{{employee.proratedIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Increment Amount')">{{employee.incrementAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('No Promotion Last 3 Year')">{{employee.noOfPromotions | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Promotion')">
                          <mat-form-field class="w150 mat-height40 mat-input-style">
                            <mat-select placeholder="Select" [(ngModel)]="employee.isPromoted"
                            (selectionChange)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin">
                              <mat-option [value]="true">Yes</mat-option>
                              <mat-option [value]="false">No</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Promotion %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.promotionPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.promotionPercentage}}</span>

                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Promotion Amount')">{{employee.promotionAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Updated CTC after Increment & Promotion')">{{employee.updatedCtcAfterIncrementAndPromotion | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Market BenchMark CTC')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.marketBenchMarkCtc"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin || isEditHODApprovedIncrementPct">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.marketBenchMarkCtc}}</span>
                        </td>                       
                        <td *ngIf="getIncrementInputColumnVisibility('Market Correction %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.marketCorrectionPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin || isEditHODApprovedIncrementPct">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.marketCorrectionPercentage}}</span>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Market Correction Amount')">{{employee.marketCorrectionAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Increment % p.a')">{{employee.finalIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(3))">{{employee.yearBeforeLastYrIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(2))">{{employee.lastToLastYrIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(1))">{{employee.lastYrIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('HOD Approved Increment %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.hodIncrementPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin || isEditHODApprovedIncrementPct">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.hodIncrementPercentage}}</span>

                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('HR Admin & MD/CEO Approved Increment %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.hrAndMdIncrementPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHrAdmin || isEditHRAdminAndMDCEOApprovedIncrementPct">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.hrAndMdIncrementPercentage}}</span>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Increment Amount')">{{employee.finalIncrementAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Annual Revised CTC (post increment)')">{{employee.finalAnnualCtc | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Monthly Revised CTC (post increment)')">{{employee.finalMonthlyCtc | number}}</td>
                        <td class="cp" *ngIf="getIncrementInputColumnVisibility('Increment Letter Format')" (click)="onClickShowIncrementLetter(employee.userId)">{{employee.incrementLetterFormat?.letterName || 'Letter not found'}}</td>                       
                      </tr>
                    </ng-container>
                  </ng-container>
                </ng-container>                
               </tbody>
               <tfoot>
                <tr>
                  <td *ngIf="getIncrementInputColumnVisibility('Department')">Total</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Band')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Employee')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Manager')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('HOD')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Designation')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('DOJ')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerMonth)">{{totalNonEligibleTotalFixedCtcPM | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerYear)">{{totalNonEligibleTotalFixedCtcPA | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')">{{totalNonEligibleEligibleEmp | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Score')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Rating')">{{totalNonEligibleFinalRating | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Increment %')">{{totalNonEligibleIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Days Served in the Increment Period')">{{totalNonEligibleDaysServedinIncrementPeriod | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Prorated Increment %')">{{totalNonEligibleProratedIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Increment Amount')">{{totalNonEligibleIncrementAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('No Promotion Last 3 Year')">{{totalNonEligibleNoOfPromotionPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Promotion')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Promotion %')">{{totalNonEligiblePromotionPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Promotion Amount')">{{totalNonEligiblePromotionAmount | number}}</td> 
                  <td *ngIf="getIncrementInputColumnVisibility('Updated CTC after Increment & Promotion')">{{totalNonEligibleupdatedCtcAfterIAndP | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Market BenchMark CTC')">{{totalNonEligibleMarketBenchMarkCtc | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Market Correction %')">{{totalNonEligiblemarketCorrectionPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Market Correction Amount')">{{totalNonEligibleMarketCorrectionAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Increment % p.a')">{{totalNonEligibleFinalIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(3))"></td>
                  <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(2))"></td>
                  <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(1))"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('HOD Approved Increment %')">{{totalNonEligibleHODIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('HR Admin & MD/CEO Approved Increment %')">{{totalNonEligibleHrAndMdIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Increment Amount')">{{totalNonEligibleFinalIncrementAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Annual Revised CTC (post increment)')">{{totalNonEligibleFinalAnnualCtc | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Monthly Revised CTC (post increment)')">{{totalNonEligibleFinalMonthlyCtc | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Increment Letter Format')"></td>
                </tr>
              </tfoot>
            </table>       
          </div>


          <!-- hod -->
          <div class="table-container" *ngIf="loggedInUserRole == 'HOD'">
            <table class="increment-input-table" *ngIf="activeIncrementInputTab" id="incrementInputEligibleTable">
              <thead>
                <tr>
                  <ng-container *ngFor="let item of IncrementInputTableHideShowAllData; let i = index">
                    <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                        <div class="verticle-center justify-content-space-between icon-style">
                            {{item.fieldName}}
                            <span class="material-icons cp ml-5 mt-3 fs-14" *ngIf="!isShowExcelData"
                                (click)="updateIncrementInputColumnVisibility(item,i)">visibility_off</span>
                        </div>
                    </th>
                </ng-container>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let department of getIncrementInputEligibleTableData">
                  <ng-container *ngFor="let bandGrade of department.bandGrades; let i = index">
                    <ng-container *ngFor="let employee of bandGrade.employeeData; let j = index">
                      <tr>
                        <td *ngIf="getIncrementInputColumnVisibility('Department') && i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(department.bandGrades)">
                          {{ department.departmentName }}
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Band') && j === 0" [attr.rowspan]="bandGrade.employeeData.length">
                          {{ bandGrade.band }}
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Employee')">{{ employee.employeeName }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Manager')">{{ employee.managerName }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('HOD')">{{ employee.hodName }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Designation')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput type="text" placeholder="Type here"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [(ngModel)]="employee.designation"
                            [disabled]="disableIncrementInputFormToHOD  || afterHODForApprovalDate || afterMDAndCEOApproval">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.designation}}</span>

                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('DOJ')">{{ employee.dateOfJoining | date: 'dd-MM-yyyy' }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerMonth)">{{employee.monthlyCtc | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerYear)">{{employee.annualCtc | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')">
                          <mat-form-field class="w150 mat-height40 mat-input-style">
                            <mat-select placeholder="Select" [(ngModel)]="employee.isEligible"
                            (selectionChange)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || afterHODForApprovalDate || afterMDAndCEOApproval">
                              <mat-option [value]="true">Yes</mat-option>
                              <mat-option [value]="false">No</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')">{{employee.individualKpiCompetencyScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')">{{employee.deptScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')">{{employee.companyScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Score')">{{employee.finalScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Rating')">{{employee.finalRating}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Increment %')">{{employee.incrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Days Served in the Increment Period')">{{employee.daysServed | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Prorated Increment %')">{{employee.proratedIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Increment Amount')">{{employee.incrementAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('No Promotion Last 3 Year')">{{employee.noOfPromotions | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Promotion')">
                          <mat-form-field class="w150 mat-height40 mat-input-style">
                            <mat-select placeholder="Select" [(ngModel)]="employee.isPromoted"
                            (selectionChange)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || afterHODForApprovalDate || afterMDAndCEOApproval">
                              <mat-option [value]="true">Yes</mat-option>
                              <mat-option [value]="false">No</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Promotion %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.promotionPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || afterHODForApprovalDate || afterMDAndCEOApproval">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.promotionPercentage}}</span>

                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Promotion Amount')">{{employee.promotionAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Updated CTC after Increment & Promotion')">{{employee.updatedCtcAfterIncrementAndPromotion | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Market BenchMark CTC')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.marketBenchMarkCtc"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || afterHODForApprovalDate || afterMDAndCEOApproval">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.marketBenchMarkCtc}}</span>

                        </td>            
                        <td *ngIf="getIncrementInputColumnVisibility('Market Correction %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.marketCorrectionPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || afterHODForApprovalDate || afterMDAndCEOApproval">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.marketCorrectionPercentage}}</span>

                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Market Correction Amount')">{{employee.marketCorrectionAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Increment % p.a')">{{employee.finalIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(3))">{{employee.yearBeforeLastYrIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(2))">{{employee.lastToLastYrIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(1))">{{employee.lastYrIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('HOD Approved Increment %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.hodIncrementPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || isEditHODApprovedIncrementPct || afterHODForApprovalDate || afterMDAndCEOApproval">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.hodIncrementPercentage}}</span>

                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('HR Admin & MD/CEO Approved Increment %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.hrAndMdIncrementPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || isEditHRAdminAndMDCEOApprovedIncrementPct || afterHODForApprovalDate || afterMDAndCEOApproval">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.hrAndMdIncrementPercentage}}</span>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Increment Amount')">{{employee.finalIncrementAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Annual Revised CTC (post increment)')">{{employee.finalAnnualCtc | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Monthly Revised CTC (post increment)')">{{employee.finalMonthlyCtc | number}}</td>
                        <td class="cp" *ngIf="getIncrementInputColumnVisibility('Increment Letter Format')" (click)="onClickShowIncrementLetter(employee.userId)">{{employee.incrementLetterFormat?.letterName || 'Letter not found'}}</td>                       
                      </tr>
                    </ng-container>
                  </ng-container>
                </ng-container>
               </tbody>
               <tfoot>
                <tr>
                  <td *ngIf="getIncrementInputColumnVisibility('Department')">Total</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Band')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Employee')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Manager')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('HOD')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Designation')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('DOJ')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerMonth)">{{totalEligibleTotalFixedCtcPM | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerYear)">{{totalEligibleTotalFixedCtcPA | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')">{{totalEligibleEligibleEmp | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Score')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Rating')">{{totalEligibleFinalRating | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Increment %')">{{totalEligibleIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Days Served in the Increment Period')">{{totalEligibleDaysServedinIncrementPeriod | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Prorated Increment %')">{{totalEligibleProratedIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Increment Amount')">{{totalEligibleIncrementAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('No Promotion Last 3 Year')">{{totalEligibleNoOfPromotionPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Promotion')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Promotion %')">{{totalEligiblePromotionPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Promotion Amount')">{{totalEligiblePromotionAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Updated CTC after Increment & Promotion')">{{totalEligibleupdatedCtcAfterIAndP | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Market BenchMark CTC')">{{totalEligibleMarketBenchMarkCtc | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Market Correction %')">{{totalEligiblemarketCorrectionPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Market Correction Amount')">{{totalEligibleMarketCorrectionAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Increment % p.a')">{{totalEligibleFinalIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(3))"></td>
                  <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(2))"></td>
                  <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(1))"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('HOD Approved Increment %')">{{totalEligibleHODIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('HR Admin & MD/CEO Approved Increment %')">{{totalEligibleHrAndMdIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Increment Amount')">{{totalEligibleFinalIncrementAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Annual Revised CTC (post increment)')">{{totalEligibleFinalAnnualCtc | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Monthly Revised CTC (post increment)')">{{totalEligibleFinalMonthlyCtc | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Increment Letter Format')"></td>
                </tr>
              </tfoot>
            </table>    
            
            <table class="increment-input-table" *ngIf="!activeIncrementInputTab" id="incrementInputNonEligibleTable">
              <thead>
                <tr>
                  <ng-container *ngFor="let item of IncrementInputTableHideShowAllData; let i = index">
                    <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                        <div class="verticle-center justify-content-space-between icon-style">
                            {{item.fieldName}}
                            <span class="material-icons cp ml-5 mt-3 fs-14" *ngIf="!isShowExcelData"
                                (click)="updateIncrementInputColumnVisibility(item,i)">visibility_off</span>
                        </div>
                    </th>
                </ng-container>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let department of getIncrementInputNonEligibleTableData">
                  <ng-container *ngFor="let bandGrade of department.bandGrades; let i = index">
                    <ng-container *ngFor="let employee of bandGrade.employeeData; let j = index">
                      <tr>
                        <td *ngIf="getIncrementInputColumnVisibility('Department') && i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(department.bandGrades)">
                          {{ department.departmentName }}
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Band') && j === 0" [attr.rowspan]="bandGrade.employeeData.length">
                          {{ bandGrade.band }}
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Employee')">{{ employee.employeeName }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Manager')">{{ employee.managerName }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('HOD')">{{ employee.hodName }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Designation')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput type="text" placeholder="Type here"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [(ngModel)]="employee.designation"
                            [disabled]="disableIncrementInputFormToHOD || afterHODForApprovalDate || afterMDAndCEOApproval">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.designation}}</span>

                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('DOJ')">{{ employee.dateOfJoining | date: 'dd-MM-yyyy' }}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerMonth)">{{employee.monthlyCtc | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerYear)">{{employee.annualCtc | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')">
                          <mat-form-field class="w150 mat-height40 mat-input-style">
                            <mat-select placeholder="Select" [(ngModel)]="employee.isEligible"
                            (selectionChange)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || afterHODForApprovalDate || afterMDAndCEOApproval">
                              <mat-option [value]="true">Yes</mat-option>
                              <mat-option [value]="false">No</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')">{{employee.individualKpiCompetencyScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')">{{employee.deptScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')">{{employee.companyScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Score')">{{employee.finalScore | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Rating')">{{employee.finalRating}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Increment %')">{{employee.incrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Days Served in the Increment Period')">{{employee.daysServed | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Prorated Increment %')">{{employee.proratedIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Increment Amount')">{{employee.incrementAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('No Promotion Last 3 Year')">{{employee.noOfPromotions | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Promotion')">
                          <mat-form-field class="w150 mat-height40 mat-input-style">
                            <mat-select placeholder="Select" [(ngModel)]="employee.isPromoted"
                            (selectionChange)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || afterHODForApprovalDate || afterMDAndCEOApproval">
                              <mat-option [value]="true">Yes</mat-option>
                              <mat-option [value]="false">No</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Promotion %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput type="number" placeholder="Type here"
                            [(ngModel)]="employee.promotionPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || afterHODForApprovalDate || afterMDAndCEOApproval">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.promotionPercentage}}</span>

                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Promotion Amount')">{{employee.promotionAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Updated CTC after Increment & Promotion')">{{employee.updatedCtcAfterIncrementAndPromotion | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Market BenchMark CTC')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.marketBenchMarkCtc"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || afterHODForApprovalDate || afterMDAndCEOApproval">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.marketBenchMarkCtc}}</span>

                        </td>                       
                        <td *ngIf="getIncrementInputColumnVisibility('Market Correction %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.marketCorrectionPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || afterHODForApprovalDate || afterMDAndCEOApproval">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.marketCorrectionPercentage}}</span>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Market Correction Amount')">{{employee.marketCorrectionAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Increment % p.a')">{{employee.finalIncrementPercentage | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(3))">{{employee.yearBeforeLastYrIncrementPercentage}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(2))">{{employee.lastToLastYrIncrementPercentage}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(1))">{{employee.lastYrIncrementPercentage}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('HOD Approved Increment %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.hodIncrementPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD || isEditHODApprovedIncrementPct || afterHODForApprovalDate || afterMDAndCEOApproval">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.hodIncrementPercentage}}</span>

                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('HR Admin & MD/CEO Approved Increment %')">
                          <mat-form-field class="mat-height40 w150 mat-input-style" *ngIf="!isShowExcelData">               
                            <input matInput  type="number" placeholder="Type here"
                            [(ngModel)]="employee.hrAndMdIncrementPercentage"
                            (blur)="onEditIncrementInputTableData(employee)"
                            [disabled]="disableIncrementInputFormToHOD  || isEditHRAdminAndMDCEOApprovedIncrementPct || afterHODForApprovalDate || afterMDAndCEOApproval">
                          </mat-form-field>
                          <span *ngIf="isShowExcelData">{{employee.hrAndMdIncrementPercentage}}</span>
                        </td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Increment Amount')">{{employee.finalIncrementAmount | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Annual Revised CTC (post increment)')">{{employee.finalAnnualCtc | number}}</td>
                        <td *ngIf="getIncrementInputColumnVisibility('Final Monthly Revised CTC (post increment)')">{{employee.finalMonthlyCtc | number}}</td>
                        <td class="cp" *ngIf="getIncrementInputColumnVisibility('Increment Letter Format')" (click)="onClickShowIncrementLetter(employee.userId)">{{employee.incrementLetterFormat?.letterName || 'Letter not found'}}</td>                       
                      </tr>
                    </ng-container>
                  </ng-container>
                </ng-container>                
               </tbody>
               <tfoot>
                <tr>
                  <td *ngIf="getIncrementInputColumnVisibility('Department')">Total</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Band')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Employee')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Manager')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('HOD')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Designation')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('DOJ')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerMonth)">{{totalNonEligibleTotalFixedCtcPM | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility(incrementCtcPerYear)">{{totalNonEligibleTotalFixedCtcPA | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Eligible Emp.')">{{totalNonEligibleEligibleEmp | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Individual KPI + Competency Score')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Department Score (out of 100)')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Company Score (out of 100)')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Score')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Rating')">{{totalNonEligibleFinalRating | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Increment %')">{{totalNonEligibleIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Days Served in the Increment Period')">{{totalNonEligibleDaysServedinIncrementPeriod | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Prorated Increment %')">{{totalNonEligibleProratedIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Increment Amount')">{{totalNonEligibleIncrementAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('No Promotion Last 3 Year')">{{totalNonEligibleNoOfPromotionPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Promotion')"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('Promotion %')">{{totalNonEligiblePromotionPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Promotion Amount')">{{totalNonEligiblePromotionAmount | number}}</td> 
                  <td *ngIf="getIncrementInputColumnVisibility('Updated CTC after Increment & Promotion')">{{totalNonEligibleupdatedCtcAfterIAndP | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Market BenchMark CTC')">{{totalNonEligibleMarketBenchMarkCtc | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Market Correction %')">{{totalNonEligiblemarketCorrectionPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Market Correction Amount')">{{totalNonEligibleMarketCorrectionAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Increment % p.a')">{{totalNonEligibleFinalIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(3))"></td>
                  <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(2))"></td>
                  <td *ngIf="getIncrementInputColumnVisibility(getIncrementColumnName(1))"></td>
                  <td *ngIf="getIncrementInputColumnVisibility('HOD Approved Increment %')">{{totalNonEligibleHODIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('HR Admin & MD/CEO Approved Increment %')">{{totalNonEligibleHrAndMdIncrementPct | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Increment Amount')">{{totalNonEligibleFinalIncrementAmount | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Annual Revised CTC (post increment)')">{{totalNonEligibleFinalAnnualCtc | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Final Monthly Revised CTC (post increment)')">{{totalNonEligibleFinalMonthlyCtc | number}}</td>
                  <td *ngIf="getIncrementInputColumnVisibility('Increment Letter Format')"></td>
                </tr>
              </tfoot>
            </table>       
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
  <ion-row class="footerBox" *ngIf="selectedTypeTabName == 'Increment Input' && activeIncrementInputTab">
    <ion-col  size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0 text-right">
      <div class="verticle-center float-right">

        <div *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
          <button type="button" *ngIf="!isHideFreezeForTheHodBtn" class="back_btn fs-14 mr-15" [style.color]="buttonColorName"  [style.border-color]="buttonColorName"
          (click)="onClickSubmitIncrementLetters()" [disabled]="isDisabledFinalIncLettersBtn">
            submit final increment letters
          </button>
         </div>

        <div *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD' || isShowMD">
          <button type="button" class="back_btn fs-14 mr-15 Generate-increment-letters" 
        (click)="onClickGenerateIncrementLetters()" *ngIf="!isHideFreezeForTheHodBtn">
          Generate increment letters
        </button>
        </div>
        <!-- *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD'" -->
         <div *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
          <button type="button" *ngIf="isHideFreezeForTheHodBtn" class="back_btn fs-14 mr-15" [style.color]="buttonColorName"  [style.border-color]="buttonColorName"
          (click)="onCLickFreezforTheHOD()" [disabled]="disableBtnsOnsendApprovelForMD">
            Freeze for the HOD
          </button>
         </div>
         <div *ngIf="loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'">
          <button *ngIf="!afterMDAndCEOApproval" type="button" class="add_btn fs-14 mr-5" [style.background-color]="buttonColorName"
          (click)="onCLickSendToMDForApproval()" [disabled]="disableBtnsOnsendApprovelForMD">
            Send to MD/CEO for Approval
          </button> 
          <div *ngIf="afterMDAndCEOApproval" class="fs-12 font_semibold text-right">Increment {{approvalStatus}} <br> {{approvalDateAndTime | date: 'dd-MM-yyyy'}}</div>
         </div>

         <div *ngIf="loggedInUserRole == 'HOD' && !isShowMD">
          <button type="button" *ngIf="!afterHODForApprovalDate" class="add_btn fs-14 mr-5" [style.background-color]="buttonColorName"
          (click)="onCLickHODsendToHrAdminToApproval()" [disabled]="disableBtnsOnsendApprovelForMD">
            Send to Hr Admin for Approval
          </button>
          <div *ngIf="afterHODForApprovalDate" class="fs-12 font_semibold text-right">Sent for HR Admin Approval on {{approvalByHodDate | date: 'dd-MM-yyyy'}} <br> </div>
         </div>

         <div *ngIf="isShowMD">
          <button type="button" class="add_btn fs-14 mr-5" [style.background-color]="buttonColorName"
          (click)="onClickMDRejectApproval()" [disabled]="isDisableApproveBtnAfterMDApproved">
            Reject
          </button>
         </div>
         <div *ngIf="isShowMD">
          <button type="button" class="add_btn fs-14 mr-5" [style.background-color]="buttonColorName"
          (click)="onClickMDApproveAproval()" [disabled]="isDisableApproveBtnAfterMDApproved">
            Approve
          </button>
         </div>
      </div>
    </ion-col>
  </ion-row>
  
    <!-- --------------------------------------Increment Summary----------------------------------- -->

    <div class="container" *ngIf="selectedTypeTabName == 'Increment Summary'">
      <ion-row class="pt-15">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
            <mat-form-field class="w150 mat-height40 mat-input-style">
              <mat-select placeholder="FY Year" [(ngModel)]="IncrementFyYear" (selectionChange)="selectedIncrementFYYear($event)">
                <mat-option [value]="item.year" *ngFor="let item of getIncrementFyYearList">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>
        </ion-col>
      </ion-row>
   
      <div class="tableCardBox mt-15 mb-15">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="display-space-between">
              <div class="d-flex">
                <mat-form-field class="mat-height40 mat-input-style">
                  <mat-icon matPrefix>search</mat-icon>
                  <input matInput type="search" placeholder="Search" [(ngModel)]="searchIncrementSummaryTableData"
                      (input)="onIncrementSummarySearch(searchIncrementSummaryTableData)">
              </mat-form-field>
              </div>
              <div>
                <p *ngIf="!completeStatusErrorMsg" class="fs-16 red">setup is not completed</p>
              </div>
              <div class="d-flex float-right">
                <button class="materialBtnIcon black_color fs-14 font_semibold mr-15" (click)="onClickDownloadIncrementSummaryExcelFile('incrementSummaryTable')">
                  <span class="material-icons">download</span></button>
                  <button [matMenuTriggerFor]="menu" [style.background-color]="buttonColorName"
                  class="customMaterialIcon fs-14">
                  <span class="material-icons">tune</span></button>
                  <mat-menu #menu="matMenu" (closed)="onMenuClose()">
                    <ion-row>
                      <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6"
                          *ngFor="let item of IncrementSummaryTableHideShowAllData" class="mat-checkbox-style">
                          <mat-checkbox [(ngModel)]="item.isVisible" class="fs-12 font_semibold "
                              (change)="onSelectIncrementSummaryHideShowCheckBox($event)" [checked]="item.isVisible"
                              value="true" (click)="$event.stopPropagation()"
                              value=true>{{item.fieldName}}</mat-checkbox>
                      </ion-col>
                      </ion-row>
                  </mat-menu>
              </div>
            </div>
          </ion-col>
        </ion-row>
  
        <ion-row class="p-5 mt-5">
         <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container Summary-Table-container">
            <table class="increment-tabs-table Increment-Summary-table" id="incrementSummaryTable">
              <thead class="sticky-header">
                <tr>
                  <ng-container *ngFor="let item of IncrementSummaryTableHideShowAllData; let i = index">
                    <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                        <div class="verticle-center justify-content-space-between icon-style">
                            {{item.fieldName}}
                            <span class="material-icons cp ml-5 mt-3 fs-14" *ngIf="!isShowExcelData"
                                (click)="updateIncrementSummaryColumnVisibility(item,i)">visibility_off</span>
                        </div>
                    </th>
                </ng-container>
                </tr>
              </thead>
             <tbody> 
              <ng-container *ngFor="let department of getIncrementSummaryTableData">
                <tr>
                  <td [attr.rowspan]="department.employeeSummaryData.length + 1" *ngIf="getIncrementSummaryColumnVisibility('Department')">{{ department.departmentName }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Band')">{{ department.employeeSummaryData[0]?.band }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Total Emp.')">{{ department.employeeSummaryData[0]?.totalEmp | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility(incrementsummaryCtc)">{{ department.employeeSummaryData[0]?.totalFixedCtc}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Eligible Emp.')">{{ department.employeeSummaryData[0]?.eligibleEmp | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Eligible Emp. Fixed CTC')">{{ department.employeeSummaryData[0]?.eligibleEmpFixedCtc | number }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Overall Increment Budget')">{{ department.employeeSummaryData[0]?.overallIncrementBudget | number }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Increment Amount')">{{ department.employeeSummaryData[0]?.incrementAmount | number }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('No of Promotions')">{{ department.employeeSummaryData[0]?.noOfPromotions | number }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Promotion Amount')">{{ department.employeeSummaryData[0]?.promotionAmount | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('No of Market Corrections')">{{ department.employeeSummaryData[0]?.noOfMarketCorrections | number }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Market Correction Amount')">{{ department.employeeSummaryData[0]?.marketCorrectionAmount | number }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Final Increment Amount')">{{ department.employeeSummaryData[0]?.finalIncrementAmount | number }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Variance')">{{ department.employeeSummaryData[0]?.variance | number }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Variance %')">{{ department.employeeSummaryData[0]?.variancePercentage | number:'1.2-2'}}</td>
                </tr>

                <ng-container *ngFor="let employee of department.employeeSummaryData.slice(1)">
                  <tr>
                    <td *ngIf="getIncrementSummaryColumnVisibility('Band')">{{ employee.band }}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility('Total Emp.')">{{ employee.totalEmp | number }}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility(incrementsummaryCtc)">{{ employee.totalFixedCtc}}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility('Eligible Emp.')">{{ employee.eligibleEmp | number}}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility('Eligible Emp. Fixed CTC')">{{ employee.eligibleEmpFixedCtc | number }}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility('Overall Increment Budget')">{{ employee.overallIncrementBudget | number }}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility('Increment Amount')">{{ employee.incrementAmount | number }}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility('No of Promotions')">{{ employee.noOfPromotions | number }}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility('Promotion Amount')">{{ employee.promotionAmount | number }}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility('No of Market Corrections')">{{ employee.noOfMarketCorrections | number }}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility('Market Correction Amount')">{{ employee.marketCorrectionAmount | number }}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility('Final Increment Amount')">{{ employee.finalIncrementAmount | number }}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility('Variance')">{{ employee.variance | number }}</td>
                    <td *ngIf="getIncrementSummaryColumnVisibility('Variance %')">{{ employee.variancePercentage | number:'1.2-2'}}</td>
                  </tr>
                </ng-container>
                       
                <tr class="Increment-Summary-Band-Total">
                  <td colspan="1" *ngIf="getIncrementSummaryColumnVisibility('Band')">Total</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Total Emp.')">{{ getDepartmentTotal(department.employeeSummaryData, 'totalEmp') }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility(incrementsummaryCtc)">{{ getDepartmentTotal(department.employeeSummaryData, 'totalFixedCtc') | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Eligible Emp.')">{{ getDepartmentTotal(department.employeeSummaryData, 'eligibleEmp') | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Eligible Emp. Fixed CTC')">{{ getDepartmentTotal(department.employeeSummaryData, 'eligibleEmpFixedCtc') | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Overall Increment Budget')">{{ getDepartmentTotal(department.employeeSummaryData, 'overallIncrementBudget') | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Increment Amount')">{{ getDepartmentTotal(department.employeeSummaryData, 'incrementAmount') | number}}</td>
                  <td  *ngIf="getIncrementSummaryColumnVisibility('No of Promotions')">{{ getDepartmentTotal(department.employeeSummaryData, 'noOfPromotions') | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Promotion Amount')">{{ getDepartmentTotal(department.employeeSummaryData, 'promotionAmount') | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('No of Market Corrections')">{{ getDepartmentTotal(department.employeeSummaryData, 'noOfMarketCorrections') | number}}</td>
                  <td  *ngIf="getIncrementSummaryColumnVisibility('Market Correction Amount')">{{ getDepartmentTotal(department.employeeSummaryData, 'marketCorrectionAmount') | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Final Increment Amount')">{{ getDepartmentTotal(department.employeeSummaryData, 'finalIncrementAmount') | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Variance')">{{ getDepartmentTotal(department.employeeSummaryData, 'variance') | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Variance %')">{{ getDepartmentTotal(department.employeeSummaryData, 'variancePercentage') | number:'1.2-2'}}</td>
              </tr>
              </ng-container>
            </tbody>
            <tfoot>
              <ng-container *ngFor="let bandTotal of getAggregatedBandTotals(); let i = index">
                <tr>
                  <td class="increment-summary-bandCount" *ngIf="i === 0 && getIncrementSummaryColumnVisibility('Department')" [attr.rowspan]="getAggregatedBandTotals().length">Total</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Band')"> {{ bandTotal.band }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Total Emp.')">{{ bandTotal.totalEmp }}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility(incrementsummaryCtc)">{{ bandTotal.totalFixedCtc | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Eligible Emp.')">{{ bandTotal.eligibleEmp | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Eligible Emp. Fixed CTC')">{{ bandTotal.eligibleEmpFixedCtc | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Overall Increment Budget')">{{ bandTotal.overallIncrementBudget | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Increment Amount')">{{ bandTotal.incrementAmount | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('No of Promotions')">{{ bandTotal.noOfPromotions | number}}</td> 
                  <td *ngIf="getIncrementSummaryColumnVisibility('Promotion Amount')">{{ bandTotal.promotionAmount | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('No of Market Corrections')">{{ bandTotal.noOfMarketCorrections | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Market Correction Amount')">{{ bandTotal.marketCorrectionAmount | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Final Increment Amount')">{{ bandTotal.finalIncrementAmount | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Variance')">{{ bandTotal.variance | number}}</td>
                  <td *ngIf="getIncrementSummaryColumnVisibility('Variance %')">{{ bandTotal.variancePercentage | number:'1.2-2'}}</td>
                </tr>
              </ng-container>
              <tr class="Increment-summary-sticky-footer">
                <td *ngIf="getIncrementSummaryColumnVisibility('Department')">Grand Total</td>
                <td *ngIf="getIncrementSummaryColumnVisibility('Band')"></td>
                <td *ngIf="getIncrementSummaryColumnVisibility('Total Emp.')">{{ getGrandTotal('totalEmp') | number}}</td>
                <td *ngIf="getIncrementSummaryColumnVisibility(incrementsummaryCtc)">{{ getGrandTotal('totalFixedCtc') | number}}</td>
                <td *ngIf="getIncrementSummaryColumnVisibility('Eligible Emp.')">{{ getGrandTotal('eligibleEmp') | number}}</td>
                <td *ngIf="getIncrementSummaryColumnVisibility('Eligible Emp. Fixed CTC')">{{ getGrandTotal('eligibleEmpFixedCtc') | number}}</td>
                <td *ngIf="getIncrementSummaryColumnVisibility('Overall Increment Budget')">{{ getGrandTotal('overallIncrementBudget') | number}}</td>
                <td *ngIf="getIncrementSummaryColumnVisibility('Increment Amount')">{{ getGrandTotal('incrementAmount') | number}}</td>
                <td *ngIf="getIncrementSummaryColumnVisibility('No of Promotions')">{{ getGrandTotal('noOfPromotions') | number}}</td>
                <td *ngIf="getIncrementSummaryColumnVisibility('Promotion Amount')">{{ getGrandTotal('promotionAmount') | number}}</td>
                <td *ngIf="getIncrementSummaryColumnVisibility('No of Market Corrections')">{{ getGrandTotal('noOfMarketCorrections') | number}}</td>
                <td *ngIf="getIncrementSummaryColumnVisibility('Market Correction Amount')">{{ getGrandTotal('marketCorrectionAmount') | number}}</td>
                <td *ngIf="getIncrementSummaryColumnVisibility('Final Increment Amount')">{{ getGrandTotal('finalIncrementAmount') | number}}</td>
                <td *ngIf="getIncrementSummaryColumnVisibility('Variance')">{{ getGrandTotal('variance') | number}}</td>
                <td *ngIf="getIncrementSummaryColumnVisibility('Variance %')">{{ getGrandTotal('variancePercentage') | number:'1.2-2' }}</td>
              </tr>
            </tfoot>
            </table>   
          </div>
         </ion-col>
        </ion-row>
      </div>
    </div>

    <!-- --------------------------------------Reports----------------------------------- -->

    <div class="container" *ngIf="selectedTypeTabName == 'Reports'">
      <ion-row class="pt-15">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
          <div class="d-flex">
            <button type="button" (click)="onClickIncrementReportsActiveTab(true)"
              [ngClass]="{'activeIncrementInputTab' : activeIncrementReportsTab}"
              class="borderRadiusRight tabsBtn center-content fs-14"><span class="displayContent">
                Eligible ({{reportsTotalEligibleCount}})</span></button>
            <button type="button" (click)="onClickIncrementReportsActiveTab(false)"
              [ngClass]="{'activeIncrementInputTab' : !activeIncrementReportsTab}"
              class="borderRadiusLeft tabsBtn center-content fs-14"><span class="displayContent">
                Non Eligible ({{reportsTotalNonEligibleCount}})</span></button>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="pt-15">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
          <div class="d-flex reportsInputFields">
            <mat-form-field class="w150 mat-height40 mat-input-style">
              <mat-select placeholder="Select Year" [(ngModel)]="IncrementFyYear" (selectionChange)="selectedIncrementFYYear($event)" >
                <mat-option [value]="item.year" *ngFor="let item of getIncrementFyYearList">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>
            <ng-multiselect-dropdown class="ml-5 w250" 
            [placeholder]="'Select Department'"
            [settings]="dropdownSettings" 
            [data]="getDepartmentByYearList"
            [(ngModel)]="selectedIncrementReportDep" 
            (onSelect)="onSelectIncrementReportDep()"
            (onDeSelect)="onDeSelectIncrementReportDep()"
            (onSelectAll)="selectAllIncrementReportDep($event)"
            (onDeSelectAll)="onDeSelectAllIncrementReportDep()"> 
          </ng-multiselect-dropdown>
           
          <ng-multiselect-dropdown class="ml-5 w250" 
            [placeholder]="'Select Band'"
            [settings]="dropdownSettings" 
            [data]="getIncrementReportBandList"
            [(ngModel)]="selectedIncrementReportBand" 
            (onSelect)="onSelectIncrementReportBand()"
            (onDeSelect)="onDeSelectIncrementReportBand()"
            (onSelectAll)="selectAllIncrementReportBand($event)"
            (onDeSelectAll)="onDeSelectAllIncrementReportBand()"> 
          </ng-multiselect-dropdown>

          <ng-multiselect-dropdown class="ml-5 w250" 
            [placeholder]="'New Designation'"
            [settings]="dropdownSettings" 
            [data]="getIncrementReportDesignationList"
            [(ngModel)]="selectedIncrementReportDesignation" 
            (onSelect)="onSelectIncrementReportDesignation()"
            (onDeSelect)="onDeSelectIncrementReportDesignation()"
            (onSelectAll)="selectAllIncrementReportDesignation($event)"
            (onDeSelectAll)="onDeSelectAllIncrementReportDesignation()"> 
          </ng-multiselect-dropdown>
        
          <ng-multiselect-dropdown class="ml-5 w250" 
            [placeholder]="'Select Manager'"
            [settings]="dropdownSettings" 
            [data]="getIncrementReportManagerList"
            [(ngModel)]="selectedIncrementReportManager" 
            (onSelect)="onSelectIncrementReportManager()"
            (onDeSelect)="onDeSelectIncrementReportManager()"
            (onSelectAll)="selectAllIncrementReportManager($event)"
            (onDeSelectAll)="onDeSelectAllIncrementReportManager()"> 
          </ng-multiselect-dropdown>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="pt-15">
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
          <div class="d-flex reportsInputFields">
            <ng-multiselect-dropdown class="ml-5 w250" 
            [placeholder]="'Select Employee'"
            [settings]="dropdownSettings" 
            [data]="getIncrementReportEmployeeList"
            [(ngModel)]="selectedIncrementReportEmployee" 
            (onSelect)="onSelectIncrementReportEmployee()"
            (onDeSelect)="onDeSelectIncrementReportEmployee()"
            (onSelectAll)="selectAllIncrementReportEmployee($event)"
            (onDeSelectAll)="onDeSelectAllIncrementReportEmployee()"> 
          </ng-multiselect-dropdown>

            <mat-form-field  class="w250 mat-height40 mat-input-style">
              <mat-select [(ngModel)]="selectedIncrementReportPromotion"  placeholder="Promotion" placeholder="Promotion"
              (selectionChange)="onSelectIncrementReportPromotion()">
              <mat-option value="true">Yes</mat-option>
              <mat-option value="false">No</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field  class="w250 mat-height40 mat-input-style">
              <mat-select [(ngModel)]="selectedIncrementReportMarketCorr"  placeholder="Market Correction" placeholder="Market Correction"
              (selectionChange)="onSelectIncrementReportMarketCorr()">
              <mat-option value="true">Yes</mat-option>
              <mat-option value="false">No</mat-option>
              </mat-select>
            </mat-form-field>

            <ng-multiselect-dropdown class="ml-5 w250" 
            [placeholder]="'Select Rating'"
            [settings]="dropdownSettings" 
            [data]="getIncrementReportRatingList"
            [(ngModel)]="selectedIncrementReportRating" 
            (onSelect)="onSelectIncrementReportRating()"
            (onDeSelect)="onDeSelectIncrementReportRating()"
            (onSelectAll)="selectAllIncrementReportRating($event)"
            (onDeSelectAll)="onDeSelectAllIncrementReportRating()"> 
          </ng-multiselect-dropdown>
          </div>
        </ion-col>
      </ion-row>
      
      <div class="tableCardBox mt-15 mb-15">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="display-space-between">
              <div class="d-flex">
                <mat-form-field class="mat-height40 mat-input-style">
                  <mat-icon matPrefix>search</mat-icon>
                  <input matInput type="search" placeholder="Search" [(ngModel)]="searchIncrementReportTableData"
                      (input)="onIncrementReportSearch(searchIncrementReportTableData)">
              </mat-form-field>
              </div>
              <div>
                <p *ngIf="!completeStatusErrorMsg" class="fs-16 red">setup is not completed</p>
              </div>
              <div class="d-flex float-right">
                <button class="materialBtnIcon black_color fs-14 font_semibold mr-15" (click)="onClickDownloadIncrementReportstExcelFile()">
                  <span class="material-icons">download</span>
                </button>
              </div>
            </div>       
          </ion-col>
        </ion-row>
        <ion-row class="p-5 mt-5">
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="table-container">
             
              <table class="increment-input-table" *ngIf="activeIncrementReportsTab" id="incrementReportsEligibleTable">
                <thead>
                  <tr>
                    <ng-container *ngFor="let item of IncrementReportsTableHideShowAllData; let i = index">
                      <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                          <div class="verticle-center justify-content-space-between icon-style">
                              {{item.fieldName}}
                          </div>
                      </th>
                  </ng-container>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let department of getIncrementReportsEligibleTableData">
                    <ng-container *ngFor="let bandGrade of department.bandGrades; let i = index">
                      <ng-container *ngFor="let employee of bandGrade.employeeData; let j = index">
                        <tr>
                          <td *ngIf="i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(department.bandGrades)">
                            {{ department.departmentName }}
                          </td>
                          <td *ngIf="j === 0" [attr.rowspan]="bandGrade.employeeData.length">
                            {{ bandGrade.band }}
                          </td>
                          <td>{{ employee.employeeName }}</td>
                          <td>{{ employee.managerName }}</td>
                          <td>{{ employee.hodName }}</td>
                          <td>{{employee.designation}}</td>
                          <td>{{ employee.dateOfJoining | date: 'dd-MM-yyyy' }}</td>
                          <td>{{employee.monthlyCtc | number}}</td>
                          <td>{{employee.annualCtc | number}}</td>
                          <td>{{ employee.isEligible ? 'Yes' : 'No' }}</td>
                          <td>{{employee.individualKpiCompetencyScore | number}}</td>
                          <td>{{employee.deptScore | number}}</td>
                          <td>{{employee.companyScore | number}}</td>
                          <td>{{employee.finalScore | number}}</td>
                          <td>{{employee.finalRating}}</td>
                          <td>{{employee.incrementPercentage | number}}</td>
                          <td>{{employee.daysServed | number}}</td>
                          <td>{{employee.proratedIncrementPercentage | number}}</td>              
                          <td>{{employee.incrementAmount | number}}</td>
                          <td>{{employee.noOfPromotions}}</td>
                          <td>{{employee.isPromoted? 'Yes' : 'No'}}</td>
                          <td>{{employee.promotionPercentage | number}}</td>
                          <td>{{employee.promotionAmount}}</td>
                          <td>{{employee.updatedCtcAfterIncrementAndPromotion | number}}</td>
                          <td>{{employee.marketBenchMarkCtc | number}}</td>
                          <td>{{employee.marketBenchMarkCtc | number}}</td>
                          <td>{{employee.marketCorrectionAmount | number}}</td>
                          <td>{{employee.finalIncrementPercentage | number}}</td>
                          <td>{{employee.yearBeforeLastYrIncrementPercentage | number}}</td>
                          <td>{{employee.lastToLastYrIncrementPercentage | number}}</td>
                          <td>{{employee.lastYrIncrementPercentage | number}}</td>
                          <td>{{employee.hodIncrementPercentage | number}}</td>
                          <td>{{employee.hrAndMdIncrementPercentage | number}}</td>
                          <td>{{employee.finalIncrementAmount | number}}</td>
                          <td>{{employee.finalAnnualCtc | number}}</td>
                          <td>{{employee.finalMonthlyCtc | number}}</td>
                          <td>{{employee.incrementLetterFormat?.letterName || 'Letter not found'}}</td>                       
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                 </tbody>
                 <tfoot>
                  <tr>
                    <td colspan="7">Total</td>
                    <td>{{reportTotalEligibleTotalFixedCtcPM | number}}</td>
                    <td>{{reportTotalEligibleTotalFixedCtcPA | number}}</td>
                    <td>{{reportTotalEligibleEligibleEmp}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{reportTotalEligibleIncrementPct | number}}</td>
                    <td>{{reportTotalEligibleDaysServedinIncrementPeriod | number}}</td>
                    <td>{{reportTotalEligibleProratedIncrementPct | number}}</td>
                    <td>{{reportTotalEligibleIncrementAmount | number}}</td>
                    <td>{{reportTotalEligibleNoOfPromotionPct | number}}</td>
                    <td></td>
                    <td>{{reportTotalEligiblePromotionPct}}</td>
                    <td>{{reportTotalEligiblePromotionAmount | number}}</td>
                    <td>{{reportTotalEligibleupdatedCtcAfterIAndP | number}}</td>
                    <td>{{reportTotalEligibleMarketBenchMarkCtc | number}}</td>
                    <td>{{reportTotalEligiblemarketCorrectionPct | number}}</td>
                    <td>{{reportTotalEligibleMarketCorrectionAmount | number}}</td>
                    <td>{{reportTotalEligibleFinalIncrementPct | number}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{reportTotalEligibleHODIncrementPct | number}}</td>
                    <td>{{reportTotalEligibleHrAndMdIncrementPct | number}}</td>
                    <td>{{reportTotalEligibleFinalIncrementAmount | number}}</td>
                    <td>{{reportTotalEligibleFinalAnnualCtc | number}}</td>
                    <td>{{reportTotalEligibleFinalMonthlyCtc | number}}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>    
              
              <table class="increment-input-table" *ngIf="!activeIncrementReportsTab" id="incrementReportsNonEligibleTable">
                <thead>
                  <tr>
                    <ng-container *ngFor="let item of IncrementReportsTableHideShowAllData; let i = index">
                      <th class="fs-14 font_bold cl-black" *ngIf="item.isVisible">
                          <div class="verticle-center justify-content-space-between icon-style">
                              {{item.fieldName}}
                              <!-- <span class="material-icons cp ml-5 mt-3 fs-14"
                                (click)="updateIncrementInputColumnVisibility(item,i)">visibility_off
                              </span> -->
                          </div>
                      </th>
                  </ng-container>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let department of getIncrementReportsNonEligibleTableData">
                    <ng-container *ngFor="let bandGrade of department.bandGrades; let i = index">
                      <ng-container *ngFor="let employee of bandGrade.employeeData; let j = index">
                        <tr>
                          <td *ngIf="i === 0 && j === 0" [attr.rowspan]="getTotalRowSpan(department.bandGrades)">
                            {{ department.departmentName }}
                          </td>
                          <td *ngIf="j === 0" [attr.rowspan]="bandGrade.employeeData.length">
                            {{ bandGrade.band }}
                          </td>
                          <td>{{ employee.employeeName }}</td>
                          <td>{{ employee.managerName }}</td>
                          <td>{{ employee.hodName }}</td>
                          <td>{{employee.designation}}</td>
                          <td>{{ employee.dateOfJoining | date: 'dd-MM-yyyy' }}</td>
                          <td>{{employee.monthlyCtc | number}}</td>
                          <td>{{employee.annualCtc | number}}</td>
                          <td>{{ employee.isEligible ? 'Yes' : 'No' }}</td>
                          <td>{{employee.individualKpiCompetencyScore | number}}</td>
                          <td>{{employee.deptScore | number}}</td>
                          <td>{{employee.companyScore | number}}</td>
                          <td>{{employee.finalScore| number }}</td>
                          <td>{{employee.finalRating}}</td>
                          <td>{{employee.incrementPercentage | number}}</td>
                          <td>{{employee.daysServed | number}}</td>
                          <td>{{employee.proratedIncrementPercentage | number}}</td>
                          <td>{{employee.incrementAmount | number}}</td>
                          <td>{{employee.noOfPromotions | number}}</td>
                          <td>{{employee.isPromoted ? 'Yes' : 'No'}}</td>
                          <td>{{employee.promotionPercentage | number}}</td>
                          <td>{{employee.promotionAmount | number}}</td>
                          <td>{{employee.updatedCtcAfterIncrementAndPromotion | number}}</td>
                          <td>{{employee.marketBenchMarkCtc | number}}</td>
                          <td>{{employee.marketCorrectionPercentage | number}}</td>
                          <td>{{employee.marketCorrectionAmount | number}}</td>
                          <td>{{employee.finalIncrementPercentage | number}}</td>
                          <td>{{employee.yearBeforeLastYrIncrementPercentage | number}}</td>
                          <td>{{employee.lastToLastYrIncrementPercentage | number}}</td>
                          <td>{{employee.lastYrIncrementPercentage | number}}</td>
                          <td>{{employee.hodIncrementPercentage | number}}</td>
                          <td>{{employee.hrAndMdIncrementPercentage | number}}</td>
                          <td>{{employee.finalIncrementAmount | number}}</td>
                          <td>{{employee.finalAnnualCtc | number}}</td>
                          <td>{{employee.finalMonthlyCtc | number}}</td>
                          <td>{{employee.incrementLetterFormat?.letterName || 'Letter not found'}}</td>                       
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                 </tbody>
                 <tfoot>
                  <tr>
                    <td colspan="7">Total</td>
                    <td>{{reportTotalNonEligibleTotalFixedCtcPM | number}}</td>
                    <td>{{reportTotalNonEligibleTotalFixedCtcPA | number}}</td>
                    <td>{{reportTotalNonEligibleEligibleEmp | number}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{reportTotalNonEligibleIncrementPct | number}}</td>
                    <td>{{reportTotalNonEligibleDaysServedinIncrementPeriod | number}}</td>
                    <td>{{reportTotalNonEligibleProratedIncrementPct | number}}</td>
                    <td>{{reportTotalNonEligibleIncrementAmount | number}}</td>
                    <td>{{reportTotalNonEligibleNoOfPromotionPct | number}}</td>
                    <td></td>
                    <td>{{reportTotalNonEligiblePromotionPct}}</td>
                    <td>{{reportTotalNonEligiblePromotionAmount | number}}</td>
                    <td>{{reportTotalNonEligibleupdatedCtcAfterIAndP | number}}</td>
                    <td>{{reportTotalNonEligibleMarketBenchMarkCtc | number}}</td>
                    <td>{{reportTotalNonEligiblemarketCorrectionPct | number}}</td>
                    <td>{{reportTotalNonEligibleMarketCorrectionAmount | number}}</td>
                    <td>{{reportTotalNonEligibleFinalIncrementPct | number}}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>{{reportTotalNonEligibleHODIncrementPct | number}}</td>
                    <td>{{reportTotalNonEligibleHrAndMdIncrementPct | number}}</td>
                    <td>{{reportTotalNonEligibleFinalIncrementAmount | number}}</td>
                    <td>{{reportTotalNonEligibleFinalAnnualCtc | number}}</td>
                    <td>{{reportTotalNonEligibleFinalMonthlyCtc | number}}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>    
            </div>
          </ion-col>
        </ion-row>
      </div>
    </div>
  <!-- --------------------------------------SetUp----------------------------------- -->

  <div class="modal fade" [style.display]="showSetupPopup? 'block' : 'none'">
    <div class="modal-dialog">
      <div class="modal-content">
        <ion-row class="p-0  headerBreadcrumb">
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
            <div class="d-flex headerBreadcrumb">
              <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickBreadcrumPMS()">
              <label class="font_semibold fs-18 ml-10 mt-5 black_color">
                <span class="cp" (click)="onClickBreadcrumPMS()">Increment</span> / <span
                  [style.color]="buttonColorName">Setup</span></label>
            </div>
          </ion-col>
          <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8" class="text-right">
            <div class="d-inline-flex p-5">
              <div class="center-content fs-14 font_regular mr-15">Increment policy -</div> 
              <div class="cp text-center font_regular mr-15">
                <span class="material-icons fs-18" (click)="onClickUploadfile('uploadfile')">upload_file</span>
                <div class="fs-12" (click)="onClickUploadfile('uploadfile')"><u>Upload</u></div>
              </div>
              <div class="cp text-center font_regular mr-15">
                <span class="material-icons fs-18" (click)="donwloadIncrementPolicy()">download</span>
                <div class="fs-12" (click)="donwloadIncrementPolicy()"><u>Download</u></div>
              </div>
              <button type="button" class="add_btn btn_blue fs-14 mr-10"
              (click)="onClickEmailContentBtn('emailContent')">
                Email Content</button>
              <button type="button" class="add_btn fs-14 mr-10" [style.background-color]="buttonColorName"
              (click)="onClickIncrementLetterBtn('incrementLetter')">Increment Letter</button>
            </div>
          </ion-col>
        </ion-row>
      </div>
      <div class="modal-body p-20">
        <div class="cardBox mb-20">
          <div class="headingOfShowBox font_medium fs-14">
            <ion-row class="p-0">
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="formLabelBoldfs16">Increment Cut off</div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10">
            <ion-row>
              <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
                <div class="formLabelSemiBoldfs14 mb-5">Year<span class="red-cl">&nbsp;*</span>
                </div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="onYearChange($event)" 
                  [disabled]="disableIncrementSetupAfterMDApproved">
                    <mat-option [value]="item.year" *ngFor="let item of companyYears" >{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ion-col>
              <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
                <div class="formLabelSemiBoldfs14 mb-5">Increment Period<span class="red-cl">&nbsp;*</span>
                </div>
                <ion-row class="p-0">
                  <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="p-0">
                    <mat-form-field class="w-90 mat-height40 mat-input-style">
                      <mat-select placeholder="Select From Month" [(ngModel)]="fromIncremnetPeriod"
                      [disabled]="disableIncrementSetupAfterMDApproved || disableIncrementSetupAfterChangeYear"
                      (selectionChange)="selectFromIncrementPeriood($event.value)">
                        <mat-option *ngFor="let item of formIncrementPeriodArray" [value]="item">
                          {{sharedService.transform(item)}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="fs-12 red pt-5" *ngIf="isInvalidFromIncrementPeriod">Select From Increment Period </div>
                  </ion-col>
                
                  <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="p-0">
                    <mat-form-field class="w-90 mat-height40 mat-input-style" >
                      <mat-select placeholder="Select To Month" [(ngModel)]="toIncremnetPeriod" 
                      [disabled]="disableIncrementSetupAfterMDApproved || disableIncrementSetupAfterChangeYear"
                      (selectionChange)="selectToIncrementPeriood($event.value)">
                        <mat-option *ngFor="let item of formIncrementPeriodArray" [value]="item">
                          {{sharedService.transform(item)}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="fs-12 red pt-5" *ngIf="isInvalidToIncrementPeriod">Select To Increment Period </div>
                  </ion-col>
                </ion-row>
              </ion-col>
              <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
                <div class="formLabelSemiBoldfs14 mb-5">Cut-off Date for Increment Eligibility<span
                    class="red-cl">&nbsp;*</span>
                </div>
                <mat-form-field class="w-80 mat-height40 mat-input-style">
                  <input matInput 
                  [matDatepicker]="incrementEligibilityDate" 
                  [(ngModel)]="cutOffDateForIncrementEligibility" 
                  placeholder="DD/MM/YYYY" 
                  [min]="minDate" 
                  [max]="maxDate" 
                  [disabled]="disableIncrementSetupAfterMDApproved || disableIncrementSetupAfterChangeYear"
                  (dateChange)="selectIncrementEligibility($event.value)">
                  <mat-datepicker-toggle matIconSuffix [for]="incrementEligibilityDate"></mat-datepicker-toggle>
                  <mat-datepicker #incrementEligibilityDate></mat-datepicker>
                </mat-form-field>
                <div class="fs-12 red pt-5" *ngIf="isINvalidCutOffDateForIncrementEligibility">Enter Cut-off Date</div>
              </ion-col>
              <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">  
                <div class="formLabelSemiBoldfs14 mb-5">Increment to be Given On?<span
                    class="red-cl">&nbsp;*</span>
                </div>
                <mat-radio-group [(ngModel)]="onSelectIncrementTotalCTC"  
                 aria-label="Select an option" 
                 class="fs-14 font_semibold"
                 [disabled]="disableIncrementSetupAfterMDApproved || disableIncrementSetupAfterChangeYear"
                 (change)="selectIncrementToBeGivenOn($event)"> 
                 <mat-radio-button value="Total Annual CTC">
                  Total CTC
                </mat-radio-button>
                <mat-radio-button value="Fixed Annual CTC" class="pl-10">
                  Fixed CTC
                </mat-radio-button>       
              </mat-radio-group> 
              <div class="fs-12 red pt-5" *ngIf="isInvalidIncrementTotalCTC">Select Increment CTC</div>
              </ion-col>
            </ion-row>
            <div class="pt-10 pb-10">
              <button type="button" class="back_btn" (click)="onClickBreadcrumPMS()">Back</button>
              <button type="button" class="add_btn fs-14 ml-10" [style.background-color]="buttonColorName"
              (click)="setUpIncrementCutOff()">Save</button>
            </div>
          </div>
        </div>
        <div>
        </div>
        <div class="cardBox mb-20">
          <div class="headingOfShowBox font_medium fs-14">
            <ion-row class="p-0">
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="formLabelBoldfs16">Score to final score converter
                  <span [style.color]="buttonColorName">(Individual Score + Individual competency)</span>
                </div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10">
            <div class="setUptable-container">
              <table class="hover mb-5 Increment-Setup-table">
                <thead class="bg-gray">
                  <tr>
                    <th class="fs-14 font_bold cl-black">Band</th>
                    <th class="fs-14 font_bold cl-black">Individual KPI score wt.</th>
                    <th class="fs-14 font_bold cl-black">Individual competency wt.</th>
                    <th class="fs-14 font_bold cl-black">Total weightage</th>
                    <th class="fs-14 font_bold cl-black"></th>
                  </tr>
                </thead>
                <tbody class="bg-white">
                  <tr *ngFor="let item of getIndividualBandList; let rowId = index"> 
                    <td class="fs-14 font_regular">
                      <span>{{item.band}}</span>
                    </td>
                    <td class="fs-14 font_regular">
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input  [(ngModel)]="item.individualKpiScoreWeightage" 
                        type="number"
                        (ngModelChange)="IndividualTotalWeightage(item)" [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled"
                        matInput placeholder="Type here" class="font_regular">
                      </mat-form-field>
                      <label *ngIf="isInValidMaxIndividualKpi && editedIndividualScoreId === rowId" class="red-cl font_regular fs-12">
                        Enter Individual KPI score weightage is less than 100
                      </label>
                      <label *ngIf="isInValidMinIndividualKpi && editedIndividualScoreId === rowId" class="red-cl font_regular fs-12">
                        Enter Individual KPI score weightage is more than 0
                      </label>
                    </td>
                    <td class="fs-14 font_regular">
                      <mat-form-field class="w-100 mat-height40 mat-input-style" >
                        <input [(ngModel)]="item.individualCompetencyWeightage" 
                        type="number"
                        (ngModelChange)="IndividualTotalWeightage(item)" [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled"
                        matInput placeholder="Type here" class="font_regular">
                      </mat-form-field>
                          <label *ngIf="isInValidMaxIndividualCompetency && editedIndividualScoreId === rowId" class="red-cl font_regular fs-12">
                        Enter Individual KPI score weightage is less than 100
                      </label>
                      <label *ngIf="isInValidMinIndividualCompetency && editedIndividualScoreId === rowId" class="red-cl font_regular fs-12">
                        Enter Individual KPI score weightage is more than 0
                      </label>
                    </td>
                    <td class="fs-14 font_regular tableDisableTd">
                      <mat-form-field class="w-100 mat-height40 mat-input-style" >
                        <input readonly [(ngModel)]="item.totalWeightage" [disabled]="editedIndividualScoreId !== rowId && !isFormDisabled"
                        matInput placeholder="Total Weightage" class="font_regular">
                      </mat-form-field>
                      <label *ngIf="IsIndividualTotalWeightage && editedIndividualScoreId === rowId" class="red-cl font_regular fs-12">
                      Individual KPI score weightage is not equal to 100
                      </label>
                    </td>
                    <td>
                     <div class="d-flex">
                      <img (click)="onClickIndividualScoreEdit(rowId)" *ngIf="editedIndividualScoreId !== rowId"  class="ml-5 cp imgEdit" title="Edit" src="././assets/icon/edit.png">
                      <span (click)="getScoreToFinalConverterIndividual()" *ngIf="editedIndividualScoreId === rowId && onCheckIconView" class="material-icons close p-10 cp fs-20">close</span>
                      <span *ngIf="editedIndividualScoreId === rowId && onCheckIconView" (click)="onSaveIndividualScoreToFinalScoreConverter()" class="material-icons link p-10 cp fs-20">check</span>
                     </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="cardBox mb-20">
          <div class="headingOfShowBox font_medium fs-14">
            <ion-row class="p-0">
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="formLabelBoldfs16">Score to final score converter
                  <span [style.color]="buttonColorName">(Individual Score + Dept Score + Company Score)</span>
                </div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10">
            <div class="setUptable-container">
              <table class="hover mb-5 Increment-Setup-table">
                <thead class="bg-gray">
                  <tr>
                    <th class="fs-14 font_bold cl-black">Band</th>
                    <th class="fs-14 font_bold cl-black">Individual KPI + <br> Competency wt.</th>
                    <th class="fs-14 font_bold cl-black">Dept KPI score</th>
                    <th class="fs-14 font_bold cl-black">Co. KPI Score weightage</th>
                    <th class="fs-14 font_bold cl-black">Total weightage</th>
                    <th class="fs-14 font_bold cl-black"></th>
                  </tr>
                </thead>
                <tbody class="bg-white">
                  <tr *ngFor="let item of ScoreToFinalScoreConverterPlusCompanyScore; let rowId = index">
                    <td class="fs-14 font_regular">
                      <span>{{item.band}}</span>
                    </td>
                    <td class="fs-14 font_regular">
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input  [(ngModel)]="item.individualCompetencyWeightage"
                        type="number"
                        (ngModelChange)="GetScoreToFinalConverterTotalWeightage(item)" 
                        [disabled]="editedIndividualDeotCompanyScoreId !== rowId && !isFormDisabled"
                        matInput placeholder="Type here" class="font_regular">
                      </mat-form-field>
                      <label *ngIf="InvalidIndividualCompetencyMaxTW && editedIndividualDeotCompanyScoreId === rowId" class="red-cl font_regular fs-12">
                        Individual KPI and Competency weightage is less than 100
                      </label>
                      <label *ngIf="InvalidIndividualCompetencyMinTW && editedIndividualDeotCompanyScoreId === rowId" class="red-cl font_regular fs-12">
                        Individual KPI and Competency weightage is more than 0
                      </label>
                    </td>
                    <td class="fs-14 font_regular">
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input  [(ngModel)]="item.deptKpiScore"
                        type="number"
                        (ngModelChange)="GetScoreToFinalConverterTotalWeightage(item)"
                        [disabled]="editedIndividualDeotCompanyScoreId !== rowId && !isFormDisabled"
                        matInput placeholder="Type here" class="font_regular">          
                      </mat-form-field>
                      <label *ngIf="InvalidDepthKpiMaxScore && editedIndividualDeotCompanyScoreId === rowId" class="red-cl font_regular fs-12">
                       Depth kpi score is less than 100
                      </label>
                      <label *ngIf="InvalidDepthKpiMinScore && editedIndividualDeotCompanyScoreId === rowId" class="red-cl font_regular fs-12">
                        Depth kpi score is more than 0
                      </label>
                    </td>   
                    <td class="fs-14 font_regular">
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input  [(ngModel)]="item.companyKpiScore"
                        type="number"
                        (ngModelChange)="GetScoreToFinalConverterTotalWeightage(item)"
                        [disabled]="editedIndividualDeotCompanyScoreId !== rowId && !isFormDisabled"
                        matInput placeholder="Type here" class="font_regular">                       
                      </mat-form-field>
                      <label *ngIf="InvalidcompanyKpiScoreMaxScore && editedIndividualDeotCompanyScoreId === rowId" class="red-cl font_regular fs-12">
                        company kpi score is less than 100
                       </label>
                       <label *ngIf="InvalidcompanyKpiScoreMinScore && editedIndividualDeotCompanyScoreId === rowId" class="red-cl font_regular fs-12">
                        company kpi score is more than 0
                       </label>
                    </td>
                    <td class="fs-14 font_regular tableDisableTd">
                      <mat-form-field class="w-100 mat-height40 mat-input-style" >
                        <input readonly [(ngModel)]="item.totalWeightage"
                        type="number"
                        [disabled]="editedIndividualDeotCompanyScoreId !== rowId && !isFormDisabled"
                        matInput placeholder="Total Weightage" class="font_regular">                       
                      </mat-form-field>
                      <label *ngIf="InvalidcompanyscoreWT && editedIndividualDeotCompanyScoreId === rowId" class="red-cl font_regular fs-12">
                       score to final score converter plus company socre weightage is not equal to 100
                       </label>
                    </td>
                    <td>
                      <div class="d-flex">
                        <img (click)="onClickIndividualDeptcompetencyScoreEdit(rowId)" *ngIf="editedIndividualDeotCompanyScoreId !== rowId" class=" ml-5 p-10 " title="Edit" src="././assets/icon/edit.png">
                        <span (click)="getScoreToFinalConverterCompany()" *ngIf="editedIndividualDeotCompanyScoreId === rowId && onCheckIconView" class="material-icons close p-10 cp fs-20">close</span>
                        <span *ngIf="editedIndividualDeotCompanyScoreId === rowId && onCheckIconView" (click)="onSaveincrementScoreToFinalScoreCompanyConverter()" class="material-icons link p-10 cp fs-20">check</span>
                       </div>          
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="cardBox mb-20">
          <div class="headingOfShowBox font_medium fs-14">
            <ion-row class="p-0">
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="formLabelBoldfs16">Score to Rating Converter
                  <span [style.color]="buttonColorName">(Individual Score + Dept Score + Company Score)</span>
                </div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10">
            <ion-row *ngFor="let item of ratingArrayForSetup">
              <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                <div class="w-100 inputBox notAllowed"><span *ngIf="item.minRange!=0">></span>{{item.minRange}}</div>
              </ion-col>
              <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput type="number" placeholder="Max Range" class="font_regular"
                    [(ngModel)]="item.maxRange" (blur)="onMaxRangeChange(item)"
                    [disabled]="disableIncrementSetupAfterMDApproved || disableIncrementSetupAfterChangeYear">
                </mat-form-field>
                <label *ngIf="item.maxRange== null && errorMsgForRating" class="red-cl font_regular fs-12">Max Range is
                  required</label>
                  <label *ngIf="isInValidMaxRange" class="red-cl font_regular fs-12">Max Range should be
                    greater than Min Range</label>
              </ion-col>
              <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput type="text" placeholder="Rating" class="font_regular"
                    [(ngModel)]="item.rating" (blur)="onRatingEmpty(item)"
                    [disabled]="disableIncrementSetupAfterMDApproved || disableIncrementSetupAfterChangeYear">
                </mat-form-field>
                <label *ngIf="item.rating== null && errorMsgForRating" class="red-cl font_regular fs-12">Rating is
                  required</label>
                  <label *ngIf="isInValidRating" class="red-cl font_regular fs-12">
                    Enter rating required
                  </label>
              </ion-col>
            </ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
              <ion-label *ngIf="ratingArrayForSetup.length==0" class="fs-16 font_regular blue mt-20 cp mr-15"
                (click)="addMoreScoreRating()">+ Add</ion-label>
              <ion-label *ngIf="ratingArrayForSetup.length!=0" class="fs-16 font_regular blue mt-20 cp mr-15"
                (click)="saveAddedScoreRating()">Save</ion-label>
              <ion-label *ngIf="ratingArrayForSetup.length!=0" class="fs-16 font_regular red mt-20 cp"
                (click)="removecreatedScoresRating()">Remove</ion-label>
            </ion-col>

            <ion-row>
              <ion-col size-sm="7" size-md="7" size-lg="7" size-xs="7" class="p-0">
                <ion-row class="p-0">
                  <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5"
                    class="p-0 tableBorder brtopLeft8 tableBg text-center">
                    <div class="formLabelSemiBoldfs14 p-10">Score Range</div>
                  </ion-col>
                  <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="p-0 tableBorder tableBg text-center">
                    <div class="formLabelSemiBoldfs14 p-10">Rating</div>
                  </ion-col>
                  <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2"
                    class="p-0 tableBorder brtopRight8 tableBg text-center" >
                    <span (click)="deleteScoreRating()" class="material-icons red p-10 cp fs-20">delete</span>
                  </ion-col>
                </ion-row>
                <ion-row class="p-0" *ngFor="let data of addedratingArray;let i=index">
                  <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="tableBorder text-center">
                    <div *ngIf="editIndexofRating!=i" class="formLabelRegularfs14 p-10">
                      <span *ngIf="data.minRange!=0">></span>{{data.minRange}} - {{data.maxRange}}
                    </div>
                    <label *ngIf="editIndexofRating==i" class="inputBox notAllowed"><span
                        *ngIf="data.minRange!=0">></span>{{data.minRange}}</label>
                    <span *ngIf="editIndexofRating==i">&nbsp;-&nbsp;</span>
                    <mat-form-field *ngIf="editIndexofRating==i" class="w-30 mat-height40 mat-input-style">
                      <input matInput type="number" placeholder="Max Range" class="font_regular"
                        [(ngModel)]="data.maxRange">
                    </mat-form-field>
                  </ion-col>
                  <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="tableBorder text-center">
                    <div *ngIf="editIndexofRating!=i" class="formLabelRegularfs14 p-10">
                      {{data.rating | titlecase}}</div>
                    <mat-form-field *ngIf="editIndexofRating==i" class="w-100 mat-height40 mat-input-style">
                      <input matInput type="number" placeholder="Normalize Score" class="font_regular"
                        [(ngModel)]="data.rating">
                    </mat-form-field>
                  </ion-col>
                  <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2" class="tableBorder text-center">
                  </ion-col>
                </ion-row>
              </ion-col>
            </ion-row>
          </div>
        </div>


        <div class="cardBox mb-20">
          <div class="headingOfShowBox font_medium fs-14">
            <ion-row class="p-0">
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="formLabelBoldfs16">Overall Increment Budget Grid
                </div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10">
            <div class="setUptable-container">
              <table class="hover mb-5 Increment-Setup-table">
                <thead class="bg-gray">
                  <tr>
                    <th class="fs-14 font_bold cl-black">Fiscal year</th>
                    <th class="fs-14 font_bold cl-black">No. of Eligible Employees</th>
                    <!-- <th class="fs-14 font_bold cl-black">Total CTC of Eligible Employees</th> -->
                     <th>{{IncrementBudgetGridCTC}}</th>
                    <th class="fs-14 font_bold cl-black">Final Increment %</th>
                    <th class="fs-14 font_bold cl-black">Final Increment Amount</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody class="bg-white">
                <ng-container *ngFor="let item of GetOverallIncrementBudgetGridData; let id = index">
                  <tr>
                    <td class="fs-14 font_regular">
                      <span>{{sharedService.transformYearToFyFormat(item.year)}}</span>
                    </td>
                    <td class="fs-14 font_regular">
                      <span>{{item.noOfEligibleEmployees}}</span>
                    </td>
                    <td class="fs-14 font_regular">
                      <span>{{item.totalCtcOfEmployees}}</span>
                    </td>
                    <td class="fs-14 font_regular">
                      <mat-form-field class="w-100 mat-height40 mat-input-style">
                        <input matInput type="number" placeholder="Text here" class="font_regular"
                          [(ngModel)]="item.finalIncrementPercentage"
                        (ngModelChange)="GetOverallIncrementBudgetGridIncrementPct(item)"
                        [disabled]="isEditingRow !== id">
                      </mat-form-field>
                      <label *ngIf="isInValidMaxOverallBudgetGrid && isEditingRow === id" class="red-cl font_regular fs-12">
                        Enter Final Increment Percentage
                      </label>
                    </td>
                    <td class="fs-14 font_regular">
                      <span>{{item.finalIncrementAmount | number}}</span>
                    </td>
                    <td>
                      <div class="d-flex">
                        <img *ngIf="isEditingRow !== id && item.year === overallIncrementBudgetGridCurrentYear" (click)="editRow(id)" 
                             class="ml-5 cp imgEdit" title="Edit" 
                             src="././assets/icon/edit.png">
                        <span *ngIf="isEditingRow === id && isShowOverallBudgetGridBtn" (click)="cancelEdit(id)" class="material-icons close p-10 cp fs-20">close</span>
                        <span *ngIf="isEditingRow === id && isShowOverallBudgetGridBtn" (click)="OnSaveFinalIncrementPercentage(item)" class="material-icons link p-10 cp fs-20">check</span>
                      </div> 
                    </td> 
                  </tr>
                </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="cardBox mb-20">
          <div class="headingOfShowBox font_medium fs-14">
            <ion-row class="p-0">
              <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                <div class="formLabelBoldfs16">Increment Grid - Band & Rating Wise
                </div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10">
            <div class="setUptable-container">
              <table class="hover mb-5 Increment-Setup-table">
                <thead class="bg-gray">
                  <tr >
                    <th class="fs-14 font_bold cl-black">Band</th>
                    <th *ngFor="let data of addedratingArray" class="fs-14 font_bold cl-black">{{data.rating | titlecase}}</th>
                    <th></th>
                  </tr> 
                </thead>
                <tbody class="bg-white">
                  <tr *ngFor="let item of IncrementGridBandList; let rowId = index">
                    <td class="fs-14 font_regular">
                      <span>{{item.band}}</span>
                    </td>
                      <td class="fs-14 font_regular" *ngFor="let data of addedratingArray; let colId = index">
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <input  
                            matInput 
                            type="number"
                            placeholder="Type text here" 
                            class="font_regular"
                            [(ngModel)]="item.incrementPercentage[colId]"
                            (ngModelChange)="InvalidBandAndRatingWise(item, colId)"
                            [disabled]="editedBandAndRatingWiseId !== rowId && !isFormDisabled"
                            >
                        </mat-form-field>
                      </td>
                      <td>
                        <div class="d-flex">
                          <img (click)="onClickBandAndRatingWiseEdit(rowId)" *ngIf="editedBandAndRatingWiseId !== rowId"  class="ml-5 cp imgEdit" title="Edit" src="././assets/icon/edit.png">
                          <span  (click)="GetIncrementGrid()"  *ngIf="editedBandAndRatingWiseId === rowId && onCheckIconView" class="material-icons close p-10 cp fs-20">close</span>
                           <span (click)="onSaveIncrementGrid()"  *ngIf="editedBandAndRatingWiseId === rowId && onCheckIconView"  class="material-icons link p-10 cp fs-20">check</span>
                         </div> 
                      </td>  
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="modal fade" [style.display]="showSetupLogs? 'block' : 'none'">
    <div class="modal-dialog">
      <div class="modal-content">
        <ion-row class="p-0  headerBreadcrumb">
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
            <div class="d-flex headerBreadcrumb">
              <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickBreadcrumPMS()">
              <label class="font_semibold fs-18 ml-10 mt-5 black_color">
                <span class="cp" (click)="onClickBreadcrumPMS()">Increment</span> / <span
                  [style.color]="buttonColorName">Logs</span></label>
            </div>
          </ion-col>
        </ion-row>
      </div>
    </div>
  </div>
</ion-content>

<ion-content class="container" *ngIf="!loggedInUserIsMD || loggedInUserRole == 'Employee'">
 <ion-row>
  <ion-col size-sm="12" size-md="6" size-lg="5" size-xs="12">
    <div class="cardBox p-20">
    <ion-row class="verticle-center">
      <ion-col size-sm="12" size-md="5" size-lg="5" size-xs="12">
        <div class="fs-14 font_semibold mr-10">Hey, {{loggedInUserName}}</div>
      </ion-col>
      <ion-col size-sm="12" size-md="7" size-lg="7" size-xs="12">
        <div class="verticle-center ">
          <div>
            <p class="fs-14 font_semibold pr-10">year</p>
          </div>
          <div>
            <mat-form-field  class="w-100 mat-height40 mat-input-style">
              <mat-select placeholder="Select Year" [(ngModel)]="IncrementFyYear" (selectionChange)="selectedIncrementFYYear($event)">
                <mat-option [value]="item.year" *ngFor="let item of getIncrementFyYearList">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </ion-col>
    </ion-row>
 
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="hr"></div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size-sm="12" size-md="4" size-lg="4" size-xs="12">
        <img src="././assets/icon/flowerBookey.png" *ngIf="ShowApproveForIsPromotedContent">
      </ion-col>
      <ion-col size-sm="12" size-md="8" size-lg="8" size-xs="12">
        <div class="fs-12 font_regular" *ngIf="ShowApproveForIsPromotedContent">25, Jun 2024.</div>
        <div class="fs-12 font_regular pt-10" *ngIf="ShowApproveForIsPromotedContent">“Congratulations on your promotion! Your new role is well-deserved, and I know that you’ll 
          bring the same dedication and leadership to your new position.”
        </div>
        <div>
          <button class="pt-10 ViewIncrementLetterBtn" *ngIf="!isDisabledFinalIncLettersBtn" (click)="onClickDownloadIncrementLetterForEmp()">View Increment Letter</button>
        </div>
      </ion-col>
    </ion-row>
    </div>
  </ion-col>
 </ion-row>
</ion-content>